import React from 'react';

import {
    ajax, plainDate, loadMarketPlaceSet, loadPickUpAddress,
    loadCarrierSets, loadMarketPlaceOrders, downloadFile,
    deleteOrdersCreation, deleteAllOrdersCreation, showPopup,
    getNavigation,  downloadOrdersCsv, loadMarketPlaceConfs,
    validateCarrierRules,
    loadAutocompleteCountries,
    autoCompleteForeignCitiesForCountry,
    loadPackageConfig,
    loadUPSProvinceCodes,
    UPSCourier, USCountryCode, canadaCountryCode
} from '../components/globals';
import { Languages } from '../components/languages';

import {
    numberValidation, emptyValidation, validate, zipValidation
} from '../components/validate';

import {
    ModalBoxFluid,UserMessage, TaskExecutingUserMessage, InputColumn, OrderCostMessage
} from '../components/utilities';
import { getOrganizationOrderCreationDto } from '../models/models';
import { UIOrderPackageConfig, UISummary, UIFilterPanel, UISummaryWidgetBar, PageTitle,
    UIDataTable, UIDownload, UIUpload, ScrollableGrid, ScrollableGridItem,
    UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox, UISelect, UIAutocomplete, SelectField } from '../components/guiElements';
import { CreditBoxWidget } from '../components/creditBoxWidget';
import { EbayConnector } from '../components/ebayConnector';
import { v4 as uuidv4 } from 'uuid';
import EditIcon from '../images/edit-icon.svg';


export class OrderCreation extends React.Component {
    constructor(props) {
        super(props);

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.logoClick = this.logoClick.bind(this);
        this.actionClick = this.actionClick.bind(this);
        this.filtersChange = this.filtersChange.bind(this);
        this.continueCalculateCarrierCost = this.continueCalculateCarrierCost.bind(this);
        this.confirmOrder = this.confirmOrder.bind(this);
        this.createOrder = this.createOrder.bind(this);
        this.createAllOrder = this.createAllOrder.bind(this);
        this.listChange = this.listChange.bind(this);
        this.listClick = this.listClick.bind(this);
        // this.addPackage = this.addPackage.bind(this);
        this.removePackage = this.removePackage.bind(this);
        this.packageServicesClick = this.packageServicesClick.bind(this);
        this.findPackagesServices = this.findPackagesServices.bind(this);
        this.manageMultipleOrders = this.manageMultipleOrders.bind(this);
        this.changeOrderServiceView = this.changeOrderServiceView.bind(this);
        this.buildOrder = this.buildOrder.bind(this);
        this.setServiceLabel = this.setServiceLabel.bind(this);
        this.buildPackagesAndServices = this.buildPackagesAndServices.bind(this);
        this.updateHeader = this.updateHeader.bind(this);
        this.findCarrier = this.findCarrier.bind(this).bind(this);
        this.findRecipient = this.findRecipient.bind(this);
        this.findPickupAddress = this.findPickupAddress.bind(this);
        this.findPickupAddressByIdentifier = this.findPickupAddressByIdentifier.bind(this);
        this.requestOrderCreation = this.requestOrderCreation.bind(this);
        this.loadCarrierAndWarehouse = this.loadCarrierAndWarehouse.bind(this);
        this.loadMarketListOrder = this.loadMarketListOrder.bind(this);
        this.orderAddressNorm = this.orderAddressNorm.bind(this);
        this.getData = this.getData.bind(this);
        this.loadOrder = this.loadOrder.bind(this);
        this.showListOrder = this.showListOrder.bind(this);
        this.uploadCsvFile = this.uploadCsvFile.bind(this);
        this.findMarketPlaceById = this.findMarketPlaceById.bind(this);
        this.clickMultiple = this.clickMultiple.bind(this);
        this.changeMultiple = this.changeMultiple.bind(this);
        this.addMultiple = this.addMultiple.bind(this);
        this.onPackageOptionChange= this.onPackageOptionChange.bind(this);
        this.removeMultiple = this.removeMultiple.bind(this);
        this.deleteOrders = this.deleteOrders.bind(this);
        this.deleteAllOrders = this.deleteAllOrders.bind(this);
        this.changeAddress = this.changeAddress.bind(this);
        this.modalAddressChange = this.modalAddressChange.bind(this);
        
        // this.modalTriangulationChange = this.modalTriangulationChange.bind(this);

        this.modalAddressClick = this.modalAddressClick.bind(this);
        this.acceptedAssurance = this.acceptedAssurance.bind(this);
        this.notAcceptedAssurance = this.notAcceptedAssurance.bind(this);
        this.onCompletedTaskExecuting = this.onCompletedTaskExecuting.bind(this);
        this.calculateCarrierCost = this.calculateCarrierCost.bind(this);
        this.callCalculateCarrierCost = this.callCalculateCarrierCost.bind(this);
        this.updateOrderCarrierCost = this.updateOrderCarrierCost.bind(this);
        this.carrierCostModalAction = this.carrierCostModalAction.bind(this);
        this.countrySelected = this.countrySelected.bind(this);
        this.citySelected = this.citySelected.bind(this);
        this.resetCarriers = this.resetCarriers.bind(this);

        this.userErrorMessage = React.createRef();
        this.userOrderRunningMessage = React.createRef(); 

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.OrderCreation[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.header = [];

        this.header.push({
                generic: { manage: 1, default: false, name: 'main', width: 3, change: this.listChange, click: null },
                caption: { type: 'checkbox', colClass: null, itemClass: 'left', value: null },
                element: { type: 'checkbox', colClass: null, itemClass: null, options: null }
        });
        this.header.push({
            generic: { manage: 0, name: 'warehouse', width: 10, change: this.listChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[0] },
            element: { type: 'select', colClass: null, itemClass: null, options: [] }
        });
        this.header.push({
            generic: { manage: 0, name: 'date', width: 7, change: null, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[1] },
            element: { type: 'label', colClass: null, itemClass: null, options: null }
        });
        this.header.push({
            generic: { manage: 0, name: 'orderNo', width: 9, change: null, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[2] },
            element: { type: 'label', colClass: null, itemClass: null, options: null }
        });
        this.header.push({
            generic: { manage: 0, name: 'courier', width: 8, change: this.listChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[3] },
            element: { type: 'select', colClass: null, itemClass: null, options: [] }
        });
        this.header.push({
            generic: { manage: 0, name: 'marketplace', width: 5, change: null, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[4] },
            element: { type: 'label', colClass: null, itemClass: 'upper', options: null }
        });
        this.header.push({
            generic: { manage: 0, name: 'services', width: 13, change: null, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[5] },
            element: { type: 'label', colClass: null, itemClass: null, options: null }
        });

        if (this.hasCreditBox()) {
            this.header.push({
                generic: { manage: 0, name: 'carrierCost', width: 3, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.list[9] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            });
        }
            

        this.header.push({
            generic: { manage: 0, name: 'mustManage', width: 1, change: null, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.list[7] },
            element: { type: 'dot', colClass: null, itemClass: 'dot-red', options: null }
        });

        this.header.push({
            generic: { manage: 0, name: 'status', width: 1, change: null, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.list[10] },
            element: { type: 'tooltip', colClass: null, itemClass: '', options: null }
        });

        this.header.push({
            generic: { manage: 1, default: null, name: 'action', width: 11, change: null, click: this.listClick },
            caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.list[6] },
            element: { type: 'button', colClass: 'center', itemClass: 'action', options: this.le.listButton }
        });

        this.listKey = 2;

        this.configs = {
            filters: {
                marketplace: { type: "text", width: "20%" },
                vector: { type: "text", width: "20%" },
                orderNum: { type: "text", width: "20%" },
                dateFrom: { type: "date", width: "15%" },
                dateTo: { type: "date", width: "15%" },

                // PARE CHE IL BE NON LI GESTISCA ANCORA
                //addressYellowAlert: { type: "checkbox" },
                //addressRedAlert: { type: "checkbox" }
            }
        };

        let mngIdx = 0, entIdx = 0;
        this.dataIndexes = this.header.map((el) => ({ manage: el.generic.manage, name: el.generic.name, idx: (el.generic.manage > 0 ? mngIdx++ : entIdx++) }));
        this.defaultManager = this.header.filter((el) => (el.generic.manage > 0)).map((el) => (el.generic.default));

        let filters = {};
        Object.keys(this.configs.filters).forEach(key => {
            filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
        });

        this.appliedFilters = filters;
        this.state = {
            modalType: 0,
            modalReference: null,
            modalData: this.buildPackagesAndServices(),
            modalMultiData: [],
            modalMsg: '',
            filters: filters,
            orders:[],
            entries: [],
            managers: Array(1).fill().map(() => (this.defaultManager.slice())),
            marketPlaceListConf: [],
            pickupAddresses: [],
            carriers: [],
            orderPackagesServices: {},
            creationIsRunning: false,
            acceptedAssuranceFrom: '',
            modalAddressReference: '',
            modalAddress: this.buildModalAdress(),
            marketplaceStartAt: 0,
            marketplaceLimit: 5,
            creditBoxOrderFrom: '',
            orderCarrierCost: 0,
            countries: [],
            suggestedCountry: [],
            countryCode: "",
            newCanadaProvinceCodes: [],
            newUSProvinceCodes: [],
            suggestedCity: [],
            packageItems: [],
            packageOptions: [],
            packages: [],
            nonEuOrders: [],
            ignoreEuCountries: false
        };
    }

    validateServicesAndPackage(serviceAndPackage) {
        let validation = [];
        for (let i = 0; i < serviceAndPackage.packages.length; i++) {
            let pack = serviceAndPackage.packages[i];
            validation.push({
                fieldObject: pack.weight,
                fieldName: 'weight',
                fieldValue: pack.weight.value,
                fieldError: 'error',
                validate: numberValidation
            });
            validation.push({
                fieldObject: pack.length,
                fieldName: 'length',
                fieldValue: pack.length.value,
                fieldError: 'error',
                validate: numberValidation
            });
            validation.push({
                fieldObject: pack.height,
                fieldName: 'height',
                fieldValue: pack.height.value,
                fieldError: 'error',
                validate: numberValidation
            });
           
            validation.push({
                fieldObject: pack.depth,
                fieldName: 'depth',
                fieldValue: pack.depth.value,
                fieldError: 'error',
                validate: numberValidation
            });

        }
        
        if (serviceAndPackage.services.chkAssurance.val) {
                validation.push({
                    fieldObject: serviceAndPackage.services.chkAssurance,
                    fieldName: 'chkAssurance',
                    fieldValue: serviceAndPackage.services.chkAssurance.data,
                    fieldError: 'error',
                    validate: numberValidation
                }
            );
        }
            
        if (serviceAndPackage.services.chkCountersign.val) {
                validation.push({
                    fieldObject: serviceAndPackage.services.chkCountersign,
                    fieldName: 'chkCountersign',
                    fieldValue: serviceAndPackage.services.chkCountersign.data,
                    fieldError: 'error',
                    validate: numberValidation
                }
            );
        }

        // if (serviceAndPackage.services.chkTriangulation.val) {
        //         validation.push({
        //             fieldObject: serviceAndPackage.services.chkTriangulation,
        //             fieldName: 'chkTriangulation',
        //             fieldValue: serviceAndPackage.services.chkTriangulation.data,
        //             fieldError: 'error',
        //             validate: emptyValidation
        //         }
        //     );
        // }
            

        return validate(validation);
    } 

    validateRecipient(data) {
        let validation = [];
        for (var key in data.recipient) {
            if(key === "fieldsValidation") {
                for(let fieldName in data.recipient.fieldsValidation) {
                    if (data.recipient.fieldsValidation[fieldName].hasOwnProperty('mandatory') && data.recipient.fieldsValidation[fieldName].mandatory) {
                        if(fieldName === 'zip') {
                            validation.push({
                                fieldObject: data.recipient[fieldName],
                                fieldName: fieldName,
                                fieldValue: data.recipient[fieldName]?.value,
                                fieldError: 'error',
                                countryName: data.recipient.country.value,
                                validate: zipValidation
                            });
                        }else {
                            validation.push({
                                fieldObject: data.recipient[fieldName],
                                fieldName: fieldName,
                                fieldValue: data.recipient[fieldName]?.value,
                                fieldError: 'error',
                                validate: emptyValidation
                            });
                        }
                        
                    }
                }
                
            }
            
        }
        return validate(validation);
    }

    validateTriangulation(data) {
        let validation = [];
        for (var key in data.triangulation) {
            if(key === "fieldsValidation") {
                for(let fieldName in data.triangulation.fieldsValidation) {
                    if (data.triangulation.fieldsValidation[fieldName].hasOwnProperty('mandatory') 
                        && data.triangulation.fieldsValidation[fieldName].mandatory) {

                            if(fieldName === 'zip') {
                                validation.push({
                                    fieldObject: data.triangulation[fieldName],
                                    fieldName: fieldName,
                                    fieldValue: data.triangulation[fieldName]?.value,
                                    fieldError: 'error',
                                    countryName: data.triangulation.country.value,
                                    validate: emptyValidation
                                });
                            } else {
                                validation.push({
                                    fieldObject: data.triangulation[fieldName],
                                    fieldName: fieldName,
                                    fieldValue: data.triangulation[fieldName]?.value,
                                    fieldError: 'error',
                                    validate: emptyValidation
                                });
                            }
                        
                    }
                }
                
            }
            
        }
        return validate(validation);
    }

    validateCarrier(mmd) {
        let validation = [];
        validation.push({
            fieldObject: mmd.carrier,
            fieldName: "carrier",
            fieldValue: mmd.carrier.sign,
            fieldError: 'error',
            validate: emptyValidation
        });
        return validate(validation);
    }

    createServiceAndPackageList(order, courier, warehouse) {
        let serviceAndPackage = this.buildPackagesAndServices();

        if (order.multiPackages == null || order.multiPackages.length == 0) {
            if (order.weight != null && order.weight > 0)
                serviceAndPackage.packages[0].weight.value = order.weight.toLocaleString();
            if (order.length != null && order.length > 0)
                serviceAndPackage.packages[0].length.value = order.length.toLocaleString();
            if (order.height != null && order.height > 0)
                serviceAndPackage.packages[0].height.value = order.height.toLocaleString();
            if (order.depth != null && order.depth > 0)
                serviceAndPackage.packages[0].depth.value = order.depth.toLocaleString();
        }
        else {
            serviceAndPackage.packages = [];
            order.multiPackages.forEach((val, idx) => {
                let pack = this.buildPackage();
                if (val.weight != null && val.weight > 0) {
                    pack.weight.value = val.weight.toLocaleString();
                }
                    
                if (val.length != null && val.length > 0) {
                    pack.length.value = val.length.toLocaleString();
                }
                    
                if (val.height != null && val.height > 0) {
                    pack.height.value = val.height.toLocaleString();
                }
                    
                if (val.depth != null && val.depth > 0) {
                    pack.depth.value = val.depth.toLocaleString();
                }
                    
                serviceAndPackage.packages.push(pack);

            });

        }  
        if (order.payload != '') {

            let payload = null;
            try {
                payload=JSON.parse(order.payload);
            }
            catch (e) {

            }
            if (payload!=null && payload.hasOwnProperty("AssuranceValue") && payload.AssuranceValue != null
                && payload.AssuranceValue > 0) {
                serviceAndPackage.services.chkAssurance.val = true;
                serviceAndPackage.services.chkAssurance.data = payload.AssuranceValue.toString();

            }
            if (payload != null && payload.hasOwnProperty("MarkValue") && payload.MarkValue != null
                && payload.MarkValue > 0) {
                serviceAndPackage.services.chkCountersign.val = true;
                serviceAndPackage.services.chkCountersign.data = payload.MarkValue.toString();
            }
            

            if (payload != null 
                && payload.hasOwnProperty("TriangulationFirstName")
                && payload.hasOwnProperty("TriangulationLastName")
                && payload.hasOwnProperty("TriangulationCountry")
                && payload.hasOwnProperty("TriangulationCity")) {
                    serviceAndPackage.services.chkTriangulation.val = true;
            }
        }


        if (order.services != null) {
            serviceAndPackage.services = {...order.services};
        }

        serviceAndPackage.courier = courier;
        serviceAndPackage.warehouse = warehouse;
        serviceAndPackage.isCountryEu = order.orderRecipient.eu;
        serviceAndPackage.isVisibleExtraEu = order.orderRecipient.is_visible_extra_eu;
        return serviceAndPackage;
    }

    buildPackage() {
        return {
                weight: { value: '', valClass: null },
                length: { value: '', valClass: null },
                height: { value: '', valClass: null },
                depth: { value: '', valClass: null }
            };
    }

    buildPackagesAndServices() {
        return {
            packages: [this.buildPackage()],
            services: {
                chkAssurance: { val: false, data: '' },
                chkCountersign: { val: false, data: '' },
                chkTriangulation: { val: false, data: '' }
            },
            courier: '',
            warehouse:'',
            isCountryEu: true,
            isVisibleExtraEu: true
        };
    }

    isValidOrder(servicesAndPackage) {

        if (servicesAndPackage.services.chkAssurance && servicesAndPackage.services.chkAssurance.val && (servicesAndPackage.services.chkAssurance.data == null || servicesAndPackage.services.chkAssurance.data.trim() == ''))
            return false;
        if (servicesAndPackage.services.chkCountersign && servicesAndPackage.services.chkCountersign.val && (servicesAndPackage.services.chkCountersign.data == null || servicesAndPackage.services.chkCountersign.data.trim() == ''))
            return false;
        for (let i = 0; i < servicesAndPackage.packages.length; i++) {
            let pack = servicesAndPackage.packages[i];
            if (pack.weight.value.trim() == ''
                || pack.length.value.trim() == ''
                || pack.height.value.trim() == ''
                || pack.depth.value.trim() == '')
                return false;
        }

        return true;
    }

    buildNewPickupAddress(addressId) {
        let newAddress = {
            id: null,
            identifier: addressId,
            isAddressFromOrder: true
        };

        return newAddress;
    }

    buildOrder(orderCreationDto, marketPlaceName, defaultPickupAddress, defaultCarrier, serviceAndPackage) {
        let ord = [];
        ord.push(defaultPickupAddress);
        ord.push(plainDate(orderCreationDto.orderDate));
        ord.push(orderCreationDto.orderNum);
        ord.push(defaultCarrier);
        ord.push(marketPlaceName);
        ord.push(""); 

        if (this.hasCreditBox()) {
            ord.push(orderCreationDto.cost);
        }
            
        ord.push("");

        if(!orderCreationDto.isForeignCountry) {
            ord.push(orderCreationDto.orderRecipientStatus);
        }
       

        this.setServiceLabel(5, ord, serviceAndPackage != null ? serviceAndPackage.services : null);

        this.setOrderSemaphore(this.getOrderSemaphoreColumn(), ord, serviceAndPackage);
        return ord;
    }

    getOrderSemaphoreColumn() {
        if (this.hasCreditBox())
            return 7;
        else
            return 6;
    }

    buildAddress() {
        let address= {
            id: 'C1',
            rowsize: 30,
            itemunit: 10,
            items: [
                { id: 'name', size: 15, text: '', type: 'text', value: '', class: null, validate: emptyValidation },
                { id: 'surname', size: 15, text: '', type: 'text', value: '', class: null },
                { id: 'address', size: 20, text: '', type: 'text', value: '', class: null, validate: emptyValidation },
                { id: 'addressNum', size: 10, text: '', type: 'text', value: '', class: null },
                { id: 'country', size: 30, text: '', type: 'text', value: '', countryCode: '', class: null },
                { id: 'city', size: 30, text: '', type: 'text', value: '', class: null, validate: emptyValidation },
                { id: 'province', size: 20, text: '', type: 'text', value: '', class: null, validate: emptyValidation, options: [] },
                { id: 'zip', size: 10, text: '', type: 'text', value: '', class: null, validate: emptyValidation },
                { id: 'number', size: 10, text: '', type: 'text', value: '', class: null },
                { id: 'email', size: 20, text: '', type: 'text', value: '', class: null },
                { id: 'note', size: 30, text: '', type: 'text', value: '', class: null },
            ]
        };

        for (let key in this.le.address) {
            let item = address.items.find(a => a.id == key);
            if (item) {
                item.text = this.le.address[key];
            }
                
        }
        return address;
    }

    buildAddressOrderDto(addressNormalized) {
        let orderDto = {};
        for (let key in addressNormalized.items) {
            orderDto[addressNormalized.items[key].id] = addressNormalized.items[key].value;
        }
        return orderDto;
    }

    buildModalAdress(order) {
        let addressOriginal = this.buildAddress();
        let addressNormalized = this.buildAddress();
  
        
        
        for (let key in addressOriginal.items) {
            addressOriginal.items[key].disabled = true;
        }

        if (order && order != null) {
            if (order.originalOrderRecipient && order.originalOrderRecipient != '') {
                for (let key in order.originalOrderRecipient) {
                    let item = addressOriginal.items.find(a => a.id == key);
                    if (item) {
                        item.value = order.originalOrderRecipient[key];
                    }
                }
            }

            if (order.normalizedOrderRecipient && order.normalizedOrderRecipient != '') {
                for (let key in order.normalizedOrderRecipient) {
                    let item = addressNormalized.items.find(a => a.id == key);
                    if (item) {
                        item.value = order.normalizedOrderRecipient[key];
                    }
                }
            }
        }

        return { original: addressOriginal, normalized: addressNormalized};
    }

    buildTriangolation() {
        const triangulation = {
            address: "",
            at: "",
            city: "",
            country: "",
            houseNo: "",
            name: "",
            number: "",
            province: "",
            surname: "",
            zip: ""
        }

        return triangulation;
    }
    resetTriangulation(triangulationData) {
        const triangulation = {
            ...triangulationData,
            address: {
                value: ""
            },
            at: {
                value: ""
            },
            houseNo: {
                value: ""
            },
            name: {
                value: ""
            },
            number: {
                value: ""
            },
            province: {
                value: ""
            },
            surname: {
                value: ""
            },
            zip: {
                value: ""
            },
        }


        return triangulation;
    }

    setOrderSemaphore(columNumber, order, serviceAndPackage) {
        order[columNumber] = serviceAndPackage != null && this.isValidOrder(serviceAndPackage) ? "dot-green" : "dot-red";
    }

    setAddressStatusIcon(order, orderCreationDto) {
        let span = "address-ok";
        switch (orderCreationDto.orderRecipientStatus) {
            case "KO":
                span = "address-ko";
                break;
            case "VERIFY":
                span = "address-verify";
                break;
            default:
                break;
        }
        order[6] = { class: span, dataVal: orderCreationDto.id };
        order[7] = { class: "pencil", dataVal: orderCreationDto.id };
    }

    setServiceLabel(columnNumber, order, service) {
        let label = "";
        if (service != null) {
            Object.keys(service).forEach((key, idx) => {
                if (service[key] && service[key].val) label += this.le.manage.additionals.services[idx] + ", ";
            });

            order[columnNumber] = label.substr(0, label.length - 2);
        }
        else
            order[columnNumber] = "";
    }

    changeEntryOrderCost(entry, newCost) {
        entry[5] = newCost;
    }

    changeOrderServiceView(orderNum, serviceAndPackages) {
        let orders = JSON.parse(JSON.stringify(this.state.entries));
        let order = orders.find(el => el[2] == orderNum);

        if (!!order) {
            if (!!serviceAndPackages) {
                this.setServiceLabel(5, order, serviceAndPackages.services);
                this.setOrderSemaphore(this.getOrderSemaphoreColumn(), order, serviceAndPackages);
            }
            else order[5] = "";
        }
        return orders;
    }

    updateHeader(warehousesList, couriersList) {
        this.header[1].element.options = warehousesList.map((el) => ({ value: el.identifier, text: el.identifier }));
        this.header[4].element.options = couriersList.map((el) => ({ value: el.sign, text: el.sign }));
    }

    findOrderById(id) { 
        let order = this.state.orders.find(a => a.id == id);

        if (order == undefined)
            return null;
        return order;
    }

    findOrder(orderNum) {
        let order= this.state.orders.find(a => a.orderNum == orderNum);

        if (order == undefined) {
            return null;
        }
        return order;
    }

    getOrderNum(entry) {
        return entry[2];
    }

    findCountryCode(countryName) {
        const foundCountry = this.state.countries
        .find((el) => el.name.toLowerCase() === countryName.toLowerCase())

        return foundCountry.code;
    }

    findPackagesServices(orderNum, noNull) {
        // debugger
        if (orderNum in this.state.orderPackagesServices) {
            
            return JSON.parse(JSON.stringify(this.state.orderPackagesServices[orderNum]));
        }
            
        return !noNull ? null : this.buildPackagesAndServices();
    }

    findRecipient(id) {
        let order = this.state.orders.filter(o => o.orderNum == id);
        let address = order.length > 0 ? order[0].normalizedOrderRecipient : this.buildAddress();

        let recipient = {};
        for (var key in address) {
            if(key === 'country') {
                const countryCode = this.findCountryCode(address[key]);
                recipient[key] = {
                    type: 'selectField',
                    value: address[key],
                    suggestedCountry: [...this.state.countries],
                    countryCode: countryCode
                }    
            } else if(key === 'city') {
                recipient[key] = {
                    type: 'autocomplete',
                    value: address[key],
                    suggestedCity: [],
                }
            }else if(key === 'province') {
                recipient[key] = {
                    type: 'text',
                    value: address[key],
                    options: []
                }
            } else {
                recipient[key] = {
                    type: 'text',
                    value: address[key]
                }
            }
        }

        recipient['fieldsValidation'] = {
            name: {id: 'name', maxLength: 50, mandatory: true },
            surname: { id: 'surname', maxLength: 50, mandatory: false },
            address: {  id: 'address', maxLength: 80, mandatory: true },
            houseNo:  {  id: 'houseno', maxLength: 10, mandatory: false },
            country: { id: 'country', maxLength: 50, mandatory: true },
            city: {  id: 'city', maxLength: 50, mandatory: true },
            province: { id: 'province', maxLength: 2, mandatory: true },
            zip: {  id: 'zip', mandatory: true },
            at: {  id: 'at', maxLength: 80, mandatory: false },
            email: { id: 'email', maxLength: 70, mandatory: false },
            number: { id: 'number', maxLength: 30, mandatory: false },
            note: { id: 'note', maxLength: 70, mandatory: false }
        };
        return recipient;
    }


    findTriangulation(id) {
        let order = this.state.orders.filter(o => o.orderNum == id);


        let orderTriangulation = order.length > 0 && order[0].orderTriangulation ? order[0].orderTriangulation : this.buildTriangolation();
        let triangulation = {};
        for (var key in orderTriangulation) {
            if(key === 'country') {
                triangulation[key] = {
                    value: orderTriangulation[key].toUpperCase(),
                    suggestedCountry: [...this.state.countries],
                    countryCode: ''
                }    
            } else if(key === 'city') {
                triangulation[key] = {
                    value: orderTriangulation[key],
                    suggestedCity: [],
                }
            }
             else {
                triangulation[key] = {
                    value: orderTriangulation[key]
                }
            }
        }

        triangulation['fieldsValidation'] = {
            name: { id: 'name', maxLength: 50, mandatory: true },
            surname: { id: 'surname', maxLength: 50, mandatory: false },
            address: { id: 'address', maxLength: 80, mandatory: true },
            houseNo:  { id: 'houseno', maxLength: 10, mandatory: false },
            country: { id: 'country', maxLength: 50, mandatory: true },
            city: { id: 'city', maxLength: 50, mandatory: true },
            province: { id: 'province', maxLength: 2, mandatory: true },
            zip: { id: 'zip', mandatory: true },
            at: { id: 'at', maxLength: 80, mandatory: false },
            number: { id: 'number', maxLength: 30, mandatory: false },
        };
        return triangulation;
    }

    findCarrier(id) {
        let defCarrier = null;
        if (this.state.carriers.length > 0) {
            defCarrier = this.state.carriers[0];
        }
        let found = this.state.carriers.find(el => el.carrierId == id);
        if (found == null)
            return defCarrier;
        return found;
    }

    findCarrierBySign(sign) {
        let found = this.state.carriers.find(el => el.sign == sign);
        if (found == undefined)
            return null;
        return found;
    }

    findPickupAddress(id) {
        let defPickup = null;
        if (this.state.pickupAddresses.length > 0) {
            defPickup = this.state.pickupAddresses[0];
        }
        let found = this.state.pickupAddresses.find(el => el.id == id);
        return (!found) ? defPickup : found;
    }

    findPickupAddressByIdentifier(identifier) {
        let found = this.state.pickupAddresses.find(el => el.identifier == identifier);
        if (found == undefined)
            found = null;
        return found;
    }

    findMarketPlaceById(id) {
        let found = this.state.marketPlaceListConf.find(el => el.id == id);
        if (found == undefined)
            return null;
        return found;
    }

    hasCreditBox() {
        return this.uc?.userProfile && this.uc?.userProfile.hasCreditBox;
    }

    requestAllOrderCreation(acceptedAssurance, creditBoxMode, ok, ko, orderCheck, assuranceCheckModal, creditBoxModeResponse) {
        if (creditBoxMode) {

            this.callCalculateCarrierCost("all",
                response => {
                    if (response.success && response.result && response.result.calc)
                        creditBoxModeResponse.call(this, response.result.calc);
                    else
                        ko.call(this, response);

                },
                error => {
                    ko.call(this, error);

                },
                verifyKo => {

                    orderCheck.call(this, verifyKo.substr(1));
                });

        } else {
            ajax(this, {
                    method: 'post',
                    url: '/api/order/all-order-creation',
                    headers: { Authorization: 'Bearer ' + this.uc.jwtToken },
                    data: {
                        assuranceChecked: acceptedAssurance,
                        orderServices: this.state.orderPackagesServices
                    }
                },
                response => {
                    let errorMessage = [];
                    let ordersList = [];
                    let assuranceCheck = false;
                    response.data.result.orders.forEach((creationResponse) => {
                        if (creationResponse.assuranceToCheck) {
                            assuranceCheck = creationResponse.assuranceToCheck;
                        }
                        else if (creationResponse.hasError) {
                            errorMessage.push("ordine " + creationResponse.orderNum + ": " + creationResponse.error);
                            ordersList[creationResponse.orderNum] = creationResponse.error;
                        }
                    });


                    if (assuranceCheck) {
                        assuranceCheckModal.call(this);
                    }
                    else if (errorMessage.length == 0)
                        ok.call(this);
                    else
                        orderCheck.call(this, errorMessage, ordersList);
                },
                error => {
                    ko.call(this, error);
                }
            );
        }
    }

    showNonEUCountryPopup(orders) {
        let nonEuOrders = [];
        if(!this.state.ignoreEuCountries) {
            const ordersKeys = Object.keys(orders);
            for(let key = 0; key < ordersKeys.length; key++) {
                let order = orders[ordersKeys[key]];
                if(!order.isCountryEu) {
                    nonEuOrders.push(ordersKeys[key]);
                }
            }
            if(nonEuOrders.length > 0) {
                this.setState({
                    modalType: 8,
                    nonEuOrders: nonEuOrders,
                    ignoreEuCountries: true
                })
                return;
            }
        }
    }

    shouldShowNonEUPopup(orders) {
        let nonEuOrders = [];
        
        if(!this.state.ignoreEuCountries) {
            const ordersKeys = Object.keys(orders);
            for(let key = 0; key < ordersKeys.length; key++) {
                let order = orders[ordersKeys[key]];
               
                if(!order.isCountryEu && order.isVisibleExtraEu) {
                    nonEuOrders.push(ordersKeys[key]);
                }
            }
            if(nonEuOrders.length > 0) {
               return true;
            }else {
                return false;
            }
        }
    }

    requestOrderCreation(acceptedAssurance, creditBoxMode, ok, ko, orderCheck, assuranceCheckModal, creditBoxModeResponse) {
        let orders = {};
        let errorMessage = [];        
        for (let i = 1; i < this.state.managers.length; i++) {
            if (this.state.managers[i][0]) {

                let orderNum = this.state.entries[i - 1][2];
                let serv = this.findPackagesServices(this.state.entries[i - 1][2]);
                if (serv === null || serv.packages == null || serv.packages.length == 0 ) {
                    errorMessage.push("Configurazione ordine:" + orderNum);
                    continue;
                }
                for (let i1 = 0; i1 < serv.packages.length; i1++) {

                    let pack = serv.packages[i1];
                    if (pack.weight.value.trim() == '' || pack.length.value.trim() == '' || pack.height.value.trim() == ''
                        || pack.depth.value.trim() == '') {
                        errorMessage.push("Configurazione ordine:" + orderNum);
                    } 
                }

                if (errorMessage.length == 0) {
                    orders[orderNum] = serv;
                   
                }
            }
        }
        if (errorMessage.length == 0) {
            if (this.hasCreditBox() && creditBoxMode) {

                this.callCalculateCarrierCost("list",
                    response => {

                        if (response.success && response.result && response.result.calc)
                            creditBoxModeResponse.call(this, response.result.calc);
                        else
                            ko.call(this, response);
                    },
                    error => {

                        ko.call(this, error);

                    },
                    verifyKo => {

                        orderCheck.call(this, verifyKo.substr(1));
                    });
            }

            else {
                ajax(this,
                    {
                        method: 'post',
                        url: '/api/order/order-creation',
                        headers: { Authorization: 'Bearer ' + this.uc.jwtToken },
                        data: {
                            assuranceChecked: acceptedAssurance,
                            orderServices: orders
                        }
                    },
                    response => {
                        let errorMessage = [];
                        let ordersList = {};
                        let assuranceCheck = false;
                        response.data.result.orders.forEach((creationResponse) => {
                            if (creationResponse.assuranceToCheck) {
                                assuranceCheck = creationResponse.assuranceToCheck;
                            }
                            else if (creationResponse.hasError) {
                                errorMessage.push("ordine " + creationResponse.orderNum + ": " + creationResponse.error);
                                ordersList[creationResponse.orderNum] = creationResponse.error;
                            }

                        });


                        if (assuranceCheck)
                            assuranceCheckModal.call(this);
                        else if (errorMessage.length == 0)
                            ok.call(this);
                        else
                            orderCheck.call(this, errorMessage, ordersList);

                    },
                    error => {
                     
                        ko.call(this, error);
                    }

                );
            }
        }
        else {

            orderCheck.call(this, errorMessage);
        }
    }

    loadCarrierAndWarehouse(listOf) {
        loadPickUpAddress(this.uc.jwtToken,
            adresses => {
                //loadOrganizationCarrier(this.uc.jwtToken,
                loadCarrierSets(this.uc.jwtToken,
                    carriers => {
                        listOf.call(this, adresses, carriers);
                    },
                    ko => { },
                    this
                );
            },
            ko => { },
            this
        );
    }

    loadMarketListOrder(name, extras) {
        let marketPlace = this.state.marketPlaceListConf.find(el => el.name.toLowerCase() == name.toLowerCase());

        if (marketPlace != null) {
            let defaultPickupAddress = "";
            if (this.state.pickupAddresses.length > 0)
                defaultPickupAddress = this.state.pickupAddresses[0];

            let defaultCarrier = "";
            if (this.state.carriers.length > 0)
                defaultCarrier = this.state.carriers[0];

            this.props.loaderShow(0);
            loadMarketPlaceOrders(marketPlace.id, extras, this.uc.jwtToken,
                data => {
                    const msg = this.le.messages.marketplaceUploaded;
                    var me = this;
                    var exitPopup = function () {

                        me.getData(me.state.navigation);
                        me.userOrderRunningMessage.current.loadMessage(true);

                    }

                    let obj = {
                        title: msg.captions[0],
                        width: "35%",
                        icon: "info",
                        messages: msg.messages,
                        buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                    };
                    this.props.popupMessage(obj);
                },
                error => {
                    this.props.loaderHide();
                    const msg = this.le.messages.error;
                    this.props.popupErrorMessage(msg.messages);
                },
                this
            );
        }
    }

    orderAddressNorm(orderId, address, jwtToken, ok, ko, ctx) {
        let id = encodeURIComponent(orderId);
        ajax(this, {
            method: 'post', url: '/api/order/order-adress-normalization/' + id, headers: { Authorization: 'Bearer ' + jwtToken },
            data: address
        },
        response => {

            ok.call(this, response.data.result.address);
        },
        error => {
            ko.call(this, error);
        }
    );

    }

    getData(navigation) {
        let me = this;
        try {
            this.props.loaderShow();
            this.loadOrder(navigation, ok => {
                this.setState({
                    ignoreEuCountries: false
                })
                this.props.loaderHide();
            },
                ko => {

                    this.props.loaderHide();

                });
        }
        catch (e) {
        }
    }

    loadOrder(navigation, okFn, koFn) {
        const filters = encodeURIComponent(JSON.stringify(this.appliedFilters));
        const url = '/api/order/order-creation/' + navigation.pageNo.value + '/' + navigation.pageSize.value + '/' + filters;
        ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                let orders = response.data.result.orders
                let newEntries = []
                let pickupAddresses = this.state.pickupAddresses;

                navigation.totalItems.value = response.data.result.tot;
                let orderPackagesServices = {};
                for (let i = 0; i < orders.length; i++) {
                    let marketPlaceName = '';
                    if (orders[i].marketplace != null) {
                        let marketPlace = this.findMarketPlaceById(orders[i].marketplace);
                        if (marketPlace != null) {
                            marketPlaceName = marketPlace.name;
                        }
                    }
                    let carrier = this.findCarrier(orders[i].carrier);
                    let senderId = '';
                    if (orders[i].warehouse == null) {
                        senderId = orders[i].sender;
                        let newAddress = this.findPickupAddressByIdentifier(senderId);
                        if (newAddress == null) {
                            newAddress = this.buildNewPickupAddress(senderId);
                            pickupAddresses.push(newAddress);
                        }
                    } else {
                        let sender = this.findPickupAddress(orders[i].warehouse);
                        senderId = !!sender ? sender.identifier : '';
                    }

                    let svc = this.createServiceAndPackageList(orders[i], carrier.sign, senderId);
                    

                    orderPackagesServices[orders[i].orderNum] = svc
                    newEntries.push(this.buildOrder(orders[i], marketPlaceName, senderId, (!!carrier ? carrier.sign : ''), (!!svc ? svc : null)));
                }
                this.setState({ orders: orders, orderPackagesServices: orderPackagesServices });
                this.showListOrder(navigation, newEntries, pickupAddresses);
                if (typeof okFn === "function") {
                    okFn.call(this);
                }
            },
            error => {
                if (typeof koFn === "function") koFn.call(this);
            }
        );
    }

    showListOrder(navigation, newEntries, newAddresses) {
        let managers = Array(newEntries.length + 1).fill().map((el) => (this.defaultManager.slice()))

        if (!!newAddresses) {
            this.updateHeader(newAddresses, this.state.carriers);
            this.setState({
                navigation: navigation, 
                managers: managers,
                entries: newEntries,
                pickupAddresses: newAddresses
            });
        }
        else {
            this.setState({ navigation: navigation, managers: managers, entries: newEntries });
        }
    }

    uploadCsvFile(typeCsv,data, ok, ko) {
        const formData = new FormData();
        formData.append("File", data);
        let tCsv = encodeURIComponent(typeCsv);
        ajax(this, { method: 'post', url: '/api/order/order-file/' + typeCsv, headers: { 'Content-Type': 'multipart/form-data', Authorization: 'Bearer ' + this.uc.jwtToken }, data: formData },
            response => {
                ok.call(this);
            },
            error => {
                ko.call(this);
            }
        );
    }

    //#endregion data functions

    //#region Events
   
    componentDidMount() {
        loadAutocompleteCountries(this.uc.jwtToken, (countries) => {
            this.setState({
                countries: countries
            });
        },
        ko => { },
        this);
        loadMarketPlaceConfs(this.uc.jwtToken,
            conf => {
                loadMarketPlaceSet(this.uc.jwtToken,
                    sets => {                       
                        let marketPlaceListConf = sets.filter((el) => (el.status)).map((el) => {
                            let dto = Object.assign(el.marketPlacePars, conf.find(i => i.name == el.name).marketPlaceSettings);
                            return {
                                id: el.marketplace, name: el.name, logo: el.logo, file: (el.name.toLowerCase() == 'amazon' ? true : false),
                                marketPlacePars: dto
                            };
                        });

                        this.setState({
                            marketPlaceListConf: marketPlaceListConf,
                            marketplaceStartAt: 0,
                        });
                    },
                    ko => { ko(); },
                    this);
            },
            ko => { },
            this
        );
        this.loadCarrierAndWarehouse(
            (pickupAddresses, couriers) => {
                let navigation = getNavigation(this.getData, this.leMain.navigation);
                this.setState({ pickupAddresses: pickupAddresses, carriers: couriers });
                this.getData(navigation);
                this.userOrderRunningMessage.current.loadMessage();
                this.userErrorMessage.current.show();
            }
        );
        loadPackageConfig(this.uc.jwtToken,
            (packages) => {
                this.setState({
                    packages
                })
            },
            (error) => {
                console.log(error, "ERROR")
            },
        this);

        loadUPSProvinceCodes(canadaCountryCode, this.uc.jwtToken,
            canadaProvinceCodes => {
                const modifiedCanadaProvinceCodes = ["", ...canadaProvinceCodes];
                const newCanadaProvinceCodes = modifiedCanadaProvinceCodes.map((provinceCode) => {
                   return  {
                        text: provinceCode,
                        value: provinceCode
                    }
                });
                this.setState({
                    newCanadaProvinceCodes
                })
            },
            ko => { },
            this
        );

        loadUPSProvinceCodes(USCountryCode, this.uc.jwtToken,
            usProvinceCodes => {
                const modifiedUSProvinceCodes = ["", ...usProvinceCodes];
                const newUSProvinceCodes = modifiedUSProvinceCodes.map((provinceCode) => {
                   return  {
                        text: provinceCode,
                        value: provinceCode
                    }
                })
                this.setState({
                    newUSProvinceCodes
                })
               
            },
            ko => { },
            this
        );
    }
    // Packages

    buildPackageOptions(packages, shouldShowDefault = true) {
        let selectedDefaultValue;
        const packageOptions = [...packages]?.map(((packageItem) => {
            if(packageItem.default && shouldShowDefault) {
                selectedDefaultValue = {
                    text: packageItem.name,
                    value: packageItem.id
                }
            }
            return {
                text: packageItem.name,
                value: packageItem.id
            }
        }));

        if(!selectedDefaultValue) {
            selectedDefaultValue = {
                text: packages[0].name,
                value: packages[0].id
            }
        }

        return {
                packageOptions: [...packageOptions],
                selectedDefaultValue: {...selectedDefaultValue}
        };
    }

    setDefaultPackageValues(packageIndex, orderIndex, selectedPackageFound) {
        const lengthValue = selectedPackageFound.length;
        const heightValue = selectedPackageFound.height;
        const depthValue = selectedPackageFound.depth;
        const weightValue = selectedPackageFound.weight;

        let newData = [...this.state.modalMultiData];
        newData[orderIndex].data['packages'][packageIndex]['length'].value = lengthValue;
        newData[orderIndex].data['packages'][packageIndex]['height'].value = heightValue;
        newData[orderIndex].data['packages'][packageIndex]['depth'].value = depthValue;
        newData[orderIndex].data['packages'][packageIndex]['weight'].value = weightValue;
        return newData;
    }

    onPackageOptionChange(selectedPackageId, orderIndex, packageIndex) {
        const selectedPackageFound = this.state.packageItems.find((item => item.id === selectedPackageId));
        const mdlData =  this.setDefaultPackageValues(packageIndex, orderIndex, selectedPackageFound);

        mdlData[orderIndex].data.packageOptions[packageIndex].selectedDefaultValue = {
            value: selectedPackageFound.id,
            text: selectedPackageFound.name
        }
        this.setState({
            modalMultiData: mdlData,
        });
    }


    changeProvinceFieldType(recipient, optionState, type = "select") {
        recipient.province.type = type;
        recipient.province.options = optionState;
    }


    listClick(ev, idx, orderNo) {
        let mdlMultiple = [];
        let order = this.findOrder(orderNo);
        let data = this.findPackagesServices(orderNo, true);
        data.recipient = this.findRecipient(orderNo);
        data.triangulation = this.findTriangulation(orderNo);
        data.packageOptions = [];
        const recipientData = data.recipient;
        const triangulationData = data.triangulation;

        if(data.recipient.province.value.length === 0) {
            this.toggleMandatoryField({
                field: 'province',
                mandatory: false,
                data: recipientData
            });
        } else if(data.triangulation.province.value.length === 0) {
            this.toggleMandatoryField({
                field: 'province',
                mandatory: false,
                data: triangulationData
            });
        }


        if(data.courier === UPSCourier && recipientData.country.countryCode === canadaCountryCode) {
            this.changeProvinceFieldType(data.recipient, this.state.newCanadaProvinceCodes);
            this.toggleMandatoryField({
                field: 'province',
                mandatory: true,
                data: recipientData
            });

        } else if(data.courier === UPSCourier && recipientData.country.countryCode === USCountryCode) {
            this.changeProvinceFieldType(data.recipient, this.state.newUSProvinceCodes);
            this.toggleMandatoryField({
                field: 'province',
                mandatory: true,
                data: recipientData
            });
        } else {
            this.changeProvinceFieldType(data.recipient, [], "text");
        }


        
        this.validateRecipient(data);
        // this.validateTriangulation(data);

        const firstTemplateOption = {
            default: false,
            name: this.le.manage.package.packageOptionDefaultValue,
            depth: "",
            id: "-1",
            height: "",
            length: "",
            weight: ""
        }

        const orderMultiPackage = data.packages;
        const packagesModified = [firstTemplateOption, ...this.state.packages];

        orderMultiPackage.forEach((packageItem, index)=> {
            data.packageOptions[index] = this.buildPackageOptions(packagesModified, false);
        });


        mdlMultiple.push({
            number: orderNo,
            customer: order.receiver,
            warehouse: this.state.entries[idx - 1][0],
            warehouseObj: this.findPickupAddressByIdentifier(this.state.entries[idx - 1][0]),
            carrier: this.findCarrierBySign(this.state.entries[idx - 1][3]),
            carriers: this.state.carriers,
            marketplace: this.state.entries[idx - 1][4],
            data: data,
            order: getOrganizationOrderCreationDto(order)
        });

        this.setState({
            modalType: 3,
            modalMultiData: mdlMultiple,
            packageItems: packagesModified,
        });
    }

    manageMultipleOrders() {
        let mdlMultiple = [];
        let packagesModified = []
        this.state.managers.forEach((elm, idx) => {
            if (elm[0] && idx > 0) {
                const orderNo = this.state.entries[idx - 1][this.listKey];
                let order = this.findOrder(orderNo);
                let data = this.findPackagesServices(orderNo, true);

                data.recipient = this.findRecipient(orderNo);
                data.triangulation = this.findTriangulation(orderNo);
                data.packageOptions = [];
                const countryCode = data.recipient.country.countryCode;
                const carrierName = data.courier;

                if(data.recipient.province.value.length === 0) {
                    data.recipient.fieldsValidation.province.mandatory = false
                }

                if(carrierName === UPSCourier && countryCode === canadaCountryCode) {
                    this.changeProvinceFieldType(data.recipient, this.state.newCanadaProvinceCodes);
                    this.toggleMandatoryField({
                        field: 'province',
                        mandatory: true,
                        data: data.recipient
                    });
                }
                 else if(carrierName === UPSCourier && countryCode === USCountryCode) {
                    this.changeProvinceFieldType(data.recipient, this.state.newUSProvinceCodes);
                    this.toggleMandatoryField({
                        field: 'province',
                        mandatory: true,
                        data: data.recipient
                    });
                } else {
                    this.changeProvinceFieldType(data.recipient, [], "text");
                    this.toggleMandatoryField({
                        field: 'province',
                        mandatory: false,
                        data: data.recipient
                    });
                }

                const items = {
                    cityName:  data.recipient.city.value,
                    provinceCode: data.recipient.province.value,
                    zipCode: data.recipient.zip.value,
                }

                if(this.getProvinceName(items)) {
                    this.toggleMandatoryField({
                        field: 'province',
                        mandatory: true,
                        data: data.recipient
                    });
                }

                this.validateRecipient(data);

                const firstTemplateOption = {
                    default: false,
                    name: this.le.manage.package.packageOptionDefaultValue,
                    depth: "",
                    id: "-1",
                    height: "",
                    length: "",
                    weight: ""
                }
        
        
                const orderMultiPackage = data.packages;
                packagesModified = [firstTemplateOption, ...this.state.packages];
            
                orderMultiPackage.forEach((packageItem, index)=> {
                    data.packageOptions[index] = this.buildPackageOptions(packagesModified, false);
                });

                mdlMultiple.push({
                    number: orderNo,
                    customer: order.receiver,
                    warehouse: this.state.entries[idx - 1][0],
                    warehouseObj: this.findPickupAddressByIdentifier(this.state.entries[idx - 1][0]),
                    carrier: this.findCarrierBySign(this.state.entries[idx - 1][3]),
                    carriers: this.state.carriers,
                    marketplace: this.state.entries[idx - 1][4],
                    data: data,
                    order: getOrganizationOrderCreationDto(order)
                });
            }
        }, this);

        if (mdlMultiple.length) {
            this.setState({
                modalType: 3,
                modalMultiData: mdlMultiple,
                packageItems: packagesModified,
            });
        }
        else {
            this.props.popupErrorMessage(this.le.message.noSelectedOrders);
        }
            
    }

    addPackage(orderIndex, packageIndex) {
        const packageOptions = this.state.modalMultiData[orderIndex].data.packageOptions;
        const newPackage = this.buildPackageOptions(this.state.packageItems);
        const selectedPackageId = newPackage.selectedDefaultValue.value;
        const selectedPackageFound = this.state.packageItems.find((item => item.id === selectedPackageId));
        this.setDefaultPackageValues(packageIndex, orderIndex, selectedPackageFound);
        packageOptions.push(newPackage);
        return packageOptions
    }

    addMultiple(ev, orderIndex, packageIndex) {
        let mdlData = this.state.modalMultiData;
        mdlData[orderIndex].data.packages.push(this.buildPackage());
        const packageOptions = this.addPackage(orderIndex, packageIndex);
        mdlData[orderIndex].data.packageOptions = packageOptions
        this.setState({
            modalMultiData: mdlData,
        });
    }

    removePackage(ev, name) {
        let who = name.split("."), mdlData = JSON.parse(JSON.stringify(this.state.modalData));
        mdlData.packages.splice(who[2], 1);
        this.setState({ modalData: mdlData });
    }

    listChange(ev, name, value, source) {
        let managers = JSON.parse(JSON.stringify(this.state.managers)), entries = JSON.parse(JSON.stringify(this.state.entries));
        const row = (source === "##header##" ? -1 : entries.findIndex((el) => (el[this.listKey] === source))), col = this.dataIndexes.find((el) => (el.name === name));
        
        if (col.manage > 0) {
            if (name === "main" && row === -1) {
                managers = managers.map(function (el) {
                    el[col.idx] = value;
                    return el;
                });
            }
            else managers[row + 1][col.idx] = value;

            if (managers.filter(function (el) { return el[0] == true }).length == 1 && managers[0][0]) {
                managers[0][0] = false;
            }


            this.setState({ managers: managers });
            this.updateOrderCarrierCost(managers);
        }
        else {
            let orderNum = this.getOrderNum(entries[row]);
            let packAndServ = this.findPackagesServices(orderNum);
            let order = this.findOrder(orderNum);

            if (name == "courier") {
                // validate..
                let carrier = this.findCarrierBySign(value);  
                            

                let ret = validateCarrierRules(carrier,
                    orderNum,
                    packAndServ.packages,
                    order.orderRecipient.zip,
                    packAndServ.services && packAndServ.services.chkCountersign && packAndServ.services.chkCountersign.val,
                    order.orderRecipient.country,
                    order.services
                    );

                if (ret != null && ret.length > 0) {
                    this.props.popupErrorMessage(ret);
                    return;
                }
            }

            entries[row][col.idx] = value;
            this.changeEntryOrderCost(entries[row], "");
            let packageAndService = this.state.orderPackagesServices;
            let carrier = null;
            let warehouse = null;
            if (packAndServ != null) {
                packAndServ[col.name] = value;
                packageAndService[orderNum] = packAndServ;
                carrier = this.findCarrierBySign(packAndServ.courier);
                warehouse = this.findPickupAddressByIdentifier(packAndServ.warehouse);
                if (carrier == null || !carrier.counterSign) {
                    packAndServ.services.chkCountersign.enabled = false;
                    packAndServ.services.chkCountersign.val = false;
                    packAndServ.services.chkCountersign.data = '';
                }
                this.setServiceLabel(5, entries[row], packAndServ.services);
            }
            this.setState({ entries: entries, orderPackagesServices: packageAndService });            

            if (order && (carrier || warehouse)) {
                let updateData = [];
                updateData.push({
                    Id: order.id,
                    CarrierId: carrier ? carrier.carrierId : null,
                    Warehouse: warehouse ? warehouse.id : null,
                });
                 let self = this;
                 ajax(this, {
                        method: 'patch',
                        url: '/api/order/orders-patch',
                        headers: { Authorization: 'Bearer ' + this.uc.jwtToken },
                        data: updateData
                    },
                    response => {
                        self.getData(self.state.navigation);
                    },
                    error => {
                        self.getData(self.state.navigation);
                    }
                 );
            }
        }
    }


    onCompletedTaskExecuting() {
        try {

            this.userErrorMessage.current.show();
            this.getData(this.state.navigation);

        }
        catch (e)
        {

        }

    }

    ebayLogoClick(token) {

        if (token == null) {
            this.setState({ ebayConnector: true });
        }
        else if (token == "") {
            this.setState({ ebayConnector: false });
        }
        else {
            this.setState({ ebayConnector: false });
            this.loadMarketListOrder('ebay', { token: token });
        }
    }

    logoClick(ev, name, id) {
        try {
            let market = this.state.marketPlaceListConf.find(el => el.id == id);

            if (market == null)
                return;
            
            if (market.file) {

                var me = this;
                this.props.loaderShow(0);
                const file = ev.target.files[0];
                this.uploadCsvFile("amazoncsv", file,
                    () => {
                        this.props.loaderHide();
                        const msg = this.le.messages.csvUploaded;

                        var exitPopup = function () {

                            me.getData(me.state.navigation);
                            me.userOrderRunningMessage.current.loadMessage(true);
                        }

                        let obj = {
                            title: msg.captions[0],
                            width: "35%",
                            icon: "info",
                            messages: msg.messages,
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                        };
                        this.props.popupMessage(obj);
                    },
                    () => {
                        this.props.loaderHide();
                        const msg = this.le.messages.error;
                        this.props.popupErrorMessage(msg.messages);
                    });
            }
            else if (name.toLowerCase() == 'ebay') {
                this.ebayLogoClick(null); // needs ebay-login
            }
            else {
                this.loadMarketListOrder(name);
            }
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    actionClick(ev, name, target) {
        try {
            if (name === 'uploadCSV') {
                this.props.loaderShow(0);
                const file = ev.target.files[0];
                this.uploadCsvFile(target,file,
                    () => {
                        this.props.loaderHide();
                        const msg = this.le.messages.csvUploaded;
                        var me = this;
                        var exitPopup = function () {

                            me.getData(me.state.navigation);
                            me.userOrderRunningMessage.current.loadMessage(true);
                        }

                        let obj = {
                            title: msg.captions[0],
                            width: "35%",
                            icon: "info",
                            messages: msg.messages,
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                        };
                        this.props.popupMessage(obj);
                       
                    },
                    () => {
                        this.props.loaderHide();
                        const msg = this.le.messages.error;
                        this.props.popupErrorMessage(msg.messages);

                    });
            }
            else if (name == 'downloadCSV') {

                downloadFile('api/filemanager/file/csvOrderTemplate', this.uc.jwtToken, error => { }, this);
            }
            else if (name == 'downloadCSVInfo') {

                downloadFile('api/filemanager/file/downloadCsvInfo', this.uc.jwtToken, error => { }, this);
            }
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    filtersChange(ev) {
        let name = ev.target.name;
        let value = (ev.target.type == 'checkbox' || ev.target.type == 'checkbox') ? ev.target.checked : ev.target.value;
        let newFilters = Object.assign({}, this.state.filters);
        newFilters[name] = value;
        this.setState({ filters: newFilters });

        if (JSON.stringify(newFilters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = newFilters;
            let navigation = this.state.navigation;
            navigation.pageNo.value = 0;
            this.getData(navigation);
        }
    }

    createAllOrder(ev, data, acceptedAssurance, creditBoxModeAccepted) {
        try {

            var me = this;
            var exitPopup = function () {
                me.getData(navigation);
            }
            var downloadCsv = function (list) {
                me.getData(navigation);
                downloadOrdersCsv(me.uc.jwtToken, list, () => me.props.popupErrorMessage("Download error"));
            }

            let navigation = this.state.navigation;
            navigation.pageNo.value = 0;
            this.props.loaderShow(0);

            let ordersObject = {};
            let errorMessage = [];
            const orders = this.state.orders;       
            for (let i = 0; i < orders.length; i++) {
                    let orderNum = orders[i].orderNum;
                    let serv = this.findPackagesServices(orderNum);
                    
                    if (serv === null || serv.packages == null || serv.packages.length == 0 ) {
                        errorMessage.push("Configurazione ordine:" + orderNum);
                        continue;
                    }
                    
                    if (errorMessage.length == 0) {
                        ordersObject[orderNum] = serv
                    }
            }


            this.requestAllOrderCreation(
                acceptedAssurance != undefined ? acceptedAssurance : false,
                this.hasCreditBox() && !creditBoxModeAccepted,
                    () => {
                        this.props.loaderHide();
                        if(this.shouldShowNonEUPopup(ordersObject)) {
                            this.showNonEUCountryPopup(ordersObject);
                            return;
                        } else {
                            const msg = this.le.messages.orderLoaded;
                            let obj = {
                                title: msg.captions[0],
                                width: "35%",
                                icon: "info",
                                messages: msg.messages,
                                buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                            };
                            this.props.popupMessage(obj);
                        }
                    },
                    (error) => {
                        this.props.loaderHide();
                        const msg = this.le.messages.error;
                        let messages = error != undefined && error != null && error.hasOwnProperty("errorMessage") ? [error.errorMessage] : msg.messages;
                        this.props.popupErrorMessage(messages);
                },
                (errorMessage, orderList) => {
                    this.props.loaderHide();

                    var messages;
                    let csv = {};
                    if (orderList != null && Object.keys(orderList).length > 0) {
                        messages = [...[" ", "Errore su " + Object.keys(orderList).length + " ordini:", " "], ...errorMessage];
                        Object.keys(orderList).forEach((key, index) => {
                            if (orderList[key].endsWith(" [*]"))
                                csv[key] = orderList[key];
                        });
                    }
                    else {
                        messages = errorMessage;
                    }

                    this.updateOrderCarrierCost(null);
                    const msg = this.le.messages.error;
                    let obj = {
                        title: msg.captions[0],
                        width: "35%",
                        icon: "error",
                        messages: messages,
                        buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                    };
                    if (Object.keys(csv).length > 0) {
                        obj.buttons.push({ name: "csv", type: "confirm", width: "40%", text: this.le.message.orderFailsCsvBtn, class: "right", click: (e) => { downloadCsv(csv) } });
                    }
                    this.props.popupMessage(obj);
                },
                (assuranceCheckModal) => {
                    this.props.loaderHide();
                    this.setState({ modalType: 4, modalMsg: '', acceptedAssuranceFrom: 'createAllOrder' });
                },
                (creditBoxModeResponse) => {
                    this.props.loaderHide();
                    this.carrierCostCalcDto = creditBoxModeResponse;
                    this.setState({ modalType: 7, modalMsg: '', creditBoxOrderFrom: "createAllOrder" });
            });
            
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    confirmOrder() {
        var me = this;
        let navigation = this.state.navigation;
        navigation.pageNo.value = 0;
        var exitPopup = function () {
            me.getData(navigation);
        }
        this.setState({
            modalType: 0
        });
        this.updateOrderCarrierCost(null);
        const msg = this.le.messages.orderLoaded;
        let obj = {
            title: msg.captions[0],
            width: "35%",
            icon: "info",
            messages: msg.messages,
            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
        };
        this.props.popupMessage(obj);
    }

    createOrder(ev, data, acceptedAssurance, creditModalAccepted) {
        try {

            var me = this;
            var exitPopup = function () {
                me.getData(navigation);
            }
            var downloadCsv = function (list) {
                me.getData(navigation);
                downloadOrdersCsv(me.uc.jwtToken, list, () => me.props.popupErrorMessage("Download error"));
            }
           
            this.props.loaderShow(0);

            
            let navigation = this.state.navigation;
            navigation.pageNo.value = 0;
            if (data == 'refresh') {                
                this.loadOrder(navigation,
                    () => {
                        try {
                            this.props.loaderHide();
                          
                        }
                        catch (e) {

                        }
                    },
                    () => { this.props.loaderHide(); }
                );
            } else {
                if (this.state.managers.find(a => a[0] == true) == undefined) {
                    this.props.loaderHide();
                    const msg = this.le.messages.noSelectedOrders;
                    
                    this.props.popupErrorMessage(msg.messages);
                    return;
                }

                let orders = {};
                let errorMessage = [];        
                for (let i = 1; i < this.state.managers.length; i++) {
                    if (this.state.managers[i][0]) {
                        let orderNum = this.state.entries[i - 1][2];
                        let serv = this.findPackagesServices(this.state.entries[i - 1][2]);
                        if (serv === null || serv.packages == null || serv.packages.length == 0 ) {
                            errorMessage.push("Configurazione ordine:" + orderNum);
                            continue;
                        }
                        for (let i1 = 0; i1 < serv.packages.length; i1++) {

                            let pack = serv.packages[i1];
                            if (pack.weight.value.trim() == '' || pack.length.value.trim() == '' || pack.height.value.trim() == ''
                                || pack.depth.value.trim() == '') {
                                errorMessage.push("Configurazione ordine:" + orderNum);
                            } 
                        }

                        if (errorMessage.length == 0) {
                            orders[orderNum] = serv;
                        
                        }
                    }
                }
                this.requestOrderCreation(
                    acceptedAssurance != undefined ? acceptedAssurance : false,
                    this.hasCreditBox() && !creditModalAccepted ? true : false,
                    () => {
                        this.props.loaderHide();
                        if(this.shouldShowNonEUPopup(orders)) {
                            this.showNonEUCountryPopup(orders);
                            return;
                        } else {
                            this.updateOrderCarrierCost(null);
                            const msg = this.le.messages.orderLoaded;
                            let obj = {
                                title: msg.captions[0],
                                width: "35%",
                                icon: "info",
                                messages: msg.messages,
                                buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                            };
                            this.props.popupMessage(obj);
                        }
                       
                    },
                    (error) => {
                        this.props.loaderHide();
                        const msg = this.le.messages.error;
                        let messages = error != undefined && error != null && error.hasOwnProperty("errorMessage") ? [error.errorMessage] :
                            msg.messages
                        this.props.popupErrorMessage(messages);

                    },
                    (errorMessage, orderList) => {
                        this.props.loaderHide();

                        var messages;
                        let csv = {};
                        if (orderList != null && Object.keys(orderList).length > 0) {
                            messages = [...[" ", "Errore su " + Object.keys(orderList).length + " ordini:", " "], ...errorMessage];
                            Object.keys(orderList).forEach((key, index) => {
                                if (orderList[key].endsWith(" [*]"))
                                    csv[key] = orderList[key];
                            });
                        }
                        else {
                            messages = errorMessage;
                        }

                        this.updateOrderCarrierCost(null);
                        const msg = this.le.messages.error;
                        let obj = {
                            title: msg.captions[0],
                            width: "35%",
                            icon: "error",
                            messages: messages,
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                        };
                        if (Object.keys(csv).length) {
                            obj.buttons.push({ name: "csv", type: "confirm", width: "40%", text: this.le.message.orderFailsCsvBtn, class: "right", click: (e) => { downloadCsv(csv) } });
                        }
                        this.props.popupMessage(obj);
                    },
                    (assuranceCheckModal) => {
                        this.props.loaderHide();
                        this.setState({ modalType: 4, modalMsg: '', acceptedAssuranceFrom: 'createOrder'});
                    },
                    (creditBoxModeResponse) => {
                        this.props.loaderHide();
                        this.carrierCostCalcDto = creditBoxModeResponse;
                        this.setState({ modalType: 7, modalMsg: '', creditBoxOrderFrom: 'createOrder' });
                    }
                );
            }
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    deleteOrders() {

        try {
            let orders = [];
            for (let i = 1; i < this.state.managers.length; i++) {
                if (this.state.managers[i][0]) {

                    let orderNum = this.state.entries[i - 1][2];
                    orders.push(orderNum);
                }

            }
           
                if (orders.length == 0)
                return;
                this.props.loaderShow(0);

            deleteOrdersCreation(orders, this.uc.jwtToken,
                    ok => {
                        this.props.loaderHide();
                        this.getData(this.state.navigation);
                    },
                    error => {
                        this.props.loaderHide();
                        const msg = this.le.messages.error;
                        let messages = error != undefined && error != null && error.hasOwnProperty("errorMessage")
                            ? [error.errorMessage] : msg.messages;
                        this.props.popupErrorMessage(messages);
                    });

            
        }
        catch (e) {

            this.props.loaderHide();

        }

    }

    deleteAllOrders() {
        try {
            var me = this;
            let okFn = function () {
                try {
                    me.props.loaderShow(0);
                    deleteAllOrdersCreation(me.uc.jwtToken,
                        ok => {
                            me.props.loaderHide();
                            me.getData(me.state.navigation);
                        },
                        error => {

                            me.props.loaderHide();
                            const msg = me.le.messages.error;
                            let messages = undefined && error != null && error.hasOwnProperty("errorMessage")
                                ? [error.errorMessage] : msg.messages;
                            me.props.popupErrorMessage(messages);
                        });
                }
                catch (e)
                {
                    me.props.loaderHide();
                    const msg = me.le.messages.error;
                    me.props.popupErrorMessage(msg.messages);
                }

            }
            showPopup(this.props.popUp, this.le.popup.deleteAllPopup.title, 'question',
                this.le.popup.deleteAllPopup.message, this.le.popup.confirmText,
                this.le.popup.cancelText,
                okFn,
                (ev, type, name) => { }
            );


        }
        catch (e) {

            this.props.loaderHide();

        }

    }

    callCalculateCarrierCost(which, ok, ko, verifyKo) {
        // debugger
        this.props.loaderHide();
        let orders = {};

        let nonEuOrders = [];

        let errorMessage = '';

        if (which != "all") {
            for (let i = 1; i < this.state.managers.length; i++) {
                if (this.state.managers[i][0]) {

                    let orderNum = this.state.entries[i - 1][2];
                    let serv = this.findPackagesServices(this.state.entries[i - 1][2]);
                    if (serv === null || serv.packages == null || serv.packages.length == 0) {
                        errorMessage = "," + "Configurazione ordine:" + orderNum;
                        continue;
                    }
                    for (let i1 = 0; i1 < serv.packages.length; i1++) {

                        let pack = serv.packages[i1];
                        if (pack.weight.value.trim() == '' || pack.length.value.trim() == '' || pack.height.value.trim() == ''
                            || pack.depth.value.trim() == '') {
                            errorMessage = "," + "Configurazione ordine:" + orderNum;
                        }

                    }

                    if (errorMessage == '') {
                        orders[orderNum] = serv;

                    }
                }
            }


            if (errorMessage.length == 0 && Object.keys(orders).length == 0) {
                const msg = this.le.messages.noSelectedOrders;
                this.props.popupErrorMessage(msg.messages);
                return;
            }
        } else {
                orders = this.state.orderPackagesServices
            }

        if (errorMessage == '' && Object.keys(orders).length > 0) {
            let orderData = {};
            orderData.orderServices = orders;
            
            if(!this.state.ignoreEuCountries) {
                const ordersKeys = Object.keys(orders);
                for(let key = 0; key < ordersKeys.length; key++) {
                    let order = orders[ordersKeys[key]];
                    if(!order.isCountryEu) {
                        nonEuOrders.push(ordersKeys[key]);
                    }
                }
                if(nonEuOrders.length > 0) {
                    this.setState({
                        modalType: 8,
                        nonEuOrders: nonEuOrders,
                        ignoreEuCountries: true
                    })
                    return
                }
            }

            this.props.loaderShow();
            
            ajax(this, {
                    method: 'post',
                    url: '/api/order/carrier-cost-calculate/' + which,
                    headers: { Authorization: 'Bearer ' + this.uc.jwtToken },
                    data: orderData
                },
                response => {
                    this.props.loaderHide();
                    const result = response.data.result.calc
                    if(result.hasError) {
                        ok.call(this, response.data);    
                    }else {
                        this.carrierCostCalcDto = result;
                        this.setState({ modalType: 7, modalMsg: '',creditBoxOrderFrom: 'createOrder'  });
                    }
                },
                error => {
                    this.props.loaderHide();
                    ko.call(this, error);
                }
            );
        }
        else {
            console.log("ERRROR")

            verifyKo.call(this, errorMessage.substr(1));
        }


    }

    continueCalculateCarrierCost() {
        const message = {
            ...this.le.messages.euCountry
        };
        message.messages.shift();
        this.setState({
            modalType: 0,
            nonEuOrders: [],
        });
        this.calculateCarrierCost();
    }

    calculateCarrierCost(ev, data) {
        this.callCalculateCarrierCost("list", data => {
            let me = this;
            var exitPopup = function () {
                let navigation = me.state.navigation;
                me.getData(navigation);
            }

            let title = this.le.carrierCostModal.captions[0];
            
            let obj = {
                title: title,
                width: "35%",
                icon: "error",
                buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
            };

            if (!data.success) {
                obj.messages = [data.errorMessage];
            }
            else if (data.result.calc.hasError) {
                obj.messages = [];
                Object.keys(data.result.calc.errorMessage).forEach(i => {
                    obj.messages.push("Ordine " + i + ": " + data.result.calc.errorMessage[i]);
                });
            }
                

            if (obj.messages) {
                this.props.popupMessage(obj);
            }
            else {
                this.getData(this.state.navigation);
               
            }

        },
        error => {
                const msg = this.le.messages.error;
                let messages = undefined && error != null && error.hasOwnProperty("errorMessage")
                    ? [error.errorMessage] : msg.messages;
                this.props.popupErrorMessage(messages);
            },
            verifyKo => {
                this.props.popupErrorMessage(verifyKo);
            });
    }

    updateOrderCarrierCost(managers) {
        let cost = 0;
        if (managers && managers != null)
            for (let i = 1; i < managers.length; i++) {
                if (managers[i][0]) {
                    let orderNum = this.state.entries[i - 1][2];
                    let order = this.findOrder(orderNum);
                    if (order && order.cost != null && order.cost != "" && order.cost != "n/d") {
                        cost = cost + parseFloat(order.cost.replace(",", "."));
                    }
                }
            }
        this.setState({ orderCarrierCost: cost.toFixed(2) });
        return cost;
    }

    packageServicesClick(ev, value) {
        if (value) {
            let modalData = JSON.parse(JSON.stringify(this.state.modalData));
            if (!this.validateServicesAndPackage(modalData)) {
                this.setState({ modalData: modalData });
                return;
            }
            let packagesNServices = JSON.parse(JSON.stringify(this.state.orderPackagesServices));
            packagesNServices[this.state.modalReference] = modalData;

            let newEntries = this.changeOrderServiceView(this.state.modalReference, this.state.modalData);
            this.setState({
                modalType: 0, orderPackagesServices: packagesNServices, modalReference: null, modalData: this.buildPackagesAndServices(), entries: newEntries
            });
        }
        else {
            this.setState({ modalType: 0, modalReference: null, modalData: this.buildPackagesAndServices() });
        }
    }

    closeMsgBox(ev) {
        this.setState({ modalType: 0 });
    }

    acceptedAssurance(ev) {
        let acceptedAssuranceFrom = this.state.acceptedAssuranceFrom;
        this.setState({ modalType: 0, acceptedAssuranceFrom: '' });
        if (acceptedAssuranceFrom == "createAllOrder") {
            this.createAllOrder(null, null, true, true);
        }
        else if (acceptedAssuranceFrom == "createOrder") {
            this.createOrder(null, "", true, true);
        }
    }

    notAcceptedAssurance(ev) {
        this.setState({ modalType: 0, acceptedAssuranceFrom:'' });
    }

    carrierCostModalAction(action) {
        let creditBoxOrderFrom = this.state.creditBoxOrderFrom;
        this.setState({ modalType: 0, creditBoxOrderFrom: '', });
        switch (action) {
            case "dismiss":
                this.setState({ modalType: 0, ignoreEuCountries: false, nonEuOrders: [] });
                break;
            case "accept":
                this.setState({ modalType: 0,  nonEuOrders: [] });
                if (creditBoxOrderFrom == "createOrder")
                    this.createOrder(null, "", false, true);
                else
                    this.createAllOrder(null, "", false, true);
                break;
            case "buy":
                this.setState({ modalType: 0 });
                this.props.navigateTo("CREDITBOXMANAGE");
                break;
            default:
                this.setState({ modalType: 0, nonEuOrders: [] });
                break;
        }
    }

    clickMultiple(ev, value) {
        if (value) {
            let modalMultiData = this.state.modalMultiData;

            let isValidate = true;
            let hasCarrier = true;
            let errors = [];
            for (let i = 0; i < modalMultiData.length; i++) {
                let mmd = modalMultiData[i];
                isValidate = this.validateServicesAndPackage(mmd.data) && isValidate;
                isValidate = this.validateRecipient(mmd.data) && isValidate;
                if(mmd.data.services.chkTriangulation.val) {
                    isValidate = this.validateTriangulation(mmd.data) && isValidate;
                } 
                
                let x = validateCarrierRules(
                    mmd.carrier,
                    mmd.number,
                    mmd.data.packages,
                    mmd.data.recipient.zip.value,
                    mmd.data.services && mmd.data.services.chkCountersign && mmd.data.services.chkCountersign.val,
                    mmd.data.recipient.country.value,
                    mmd.data.services);
                if (x && x.length > 0) {
                    errors = [...errors, ...x];
                    mmd.carrier = {};
                    mmd.data.courier = null;
                    hasCarrier = false;
                }
                isValidate = this.validateCarrier(mmd) && isValidate;
            }
            if (!isValidate) {
                errors.push(Languages.getSection("SingleOrderCreation").messages[2].messages[0]);
            }



            this.setState({ modalMultiData: modalMultiData });
            if (!isValidate || !hasCarrier) {
                this.props.popupErrorMessage(errors);
                return;
            }

            let packagesNServices = JSON.parse(JSON.stringify(this.state.orderPackagesServices)),
                entries = JSON.parse(JSON.stringify(this.state.entries));

            let updateData = [];

            modalMultiData.forEach(elm => {
                packagesNServices[elm.number] = elm.data;
                let entry = entries.find(el => (el[this.listKey] === elm.number), this);
                this.setServiceLabel(5, entry, elm.data.services);
                this.setOrderSemaphore(this.getOrderSemaphoreColumn(), entry, elm.data);
                let rec = {};
                let triangTransformedObject = {};

                Object.entries(elm.data.recipient).map(([key, val], ind) => {
                    rec[key] = val.value;
                    if(key === 'country') {
                        rec['countryCode'] = val.countryCode
                    }
                });


                
                if(elm.data.services.chkTriangulation.val) {
                    Object.entries(elm.data.triangulation).map(([key, val], ind) => {
                        triangTransformedObject[key] = val.value;
                    });
    
                    updateData.push({
                        Id: elm.order.id,
                        Package: elm.data.packages,
                        Services: elm.data.services,
                        Recipient: rec,
                        CarrierId: elm.carrier.carrierId,
                        Triangulation: triangTransformedObject
                    });
                }else {
                    updateData.push({
                        Id: elm.order.id,
                        Package: elm.data.packages,
                        Services: elm.data.services,
                        Recipient: rec,
                        CarrierId: elm.carrier.carrierId,
                    });
                }
            }, this);


            let self = this;
            ajax(this, {
                    method: 'patch',
                    url: '/api/order/orders-patch',
                    headers: { Authorization: 'Bearer ' + this.uc.jwtToken },
                    data: updateData
                },
                response => {
                    self.setState({
                        modalType: 0, modalMultiData: [], orderPackagesServices: packagesNServices, entries: entries
                    });
                    self.getData(self.state.navigation);
                },
                error => {
                    this.props.popupErrorMessage(errors);
                }
            );
        } else {
            this.setState({ modalType: 0, modalMultiData: [] });
        }
            
    }

    changeMultiple(ev, type, orderIndex, packIndex, name, value, items) {
        let mdlData = this.state.modalMultiData;
        const data = mdlData[orderIndex].data.recipient;
        if (type === 'packages'){ 
            mdlData[orderIndex].data['packages'][packIndex][name].value = value;
        } else if (type == 'services') {
            mdlData[orderIndex].data['services'][name].val = value;
            mdlData[orderIndex].data['services'][name].data = "";
           if(name === "chkTriangulation") {
                mdlData[orderIndex].data['triangulation'] = this.resetTriangulation(mdlData[orderIndex].data['triangulation']);
           }
        } else if (type == 'servicesdata') {
            mdlData[orderIndex].data['services'][name].data = value;
        } else if (type == 'recipient' || type == 'triangulation') {
            mdlData[orderIndex].data[type][name].value = value;
            
              if(name === 'city' ) {
                let countryCode;
                const countryName = mdlData[orderIndex].data[type]['country'].value;
                this.state.countries
                .filter((el) => el.name.toLowerCase().includes(countryName.toLowerCase()))
                .forEach(el => {
                    countryCode = el.code;
                });

                if (value.length >= 3) {
                    (autoCompleteForeignCitiesForCountry(this.uc.jwtToken, value,
                        countryCode,
                        response => {
                            const suggested = response.map((el) => {
                                return { 
                                    id: el.id,
                                    label: el.label,
                                    labelShort:el.labelShort, 
                                    cityName: el.cityName,
                                    provinceCode: el.provinceCode,
                                    zipCode: el.value
                                }
                            });
                            mdlData[orderIndex].data[type][name].suggestedCity = suggested;
                        }));
                } 
            }
        } else if (type == 'carrier') {
            mdlData[orderIndex].data['services'].chkCountersign.data = "";
            mdlData[orderIndex].data['services'].chkCountersign.val = false;
            mdlData[orderIndex].data['services'].chkTriangulation.val = false;
            mdlData[orderIndex].data['triangulation'] = this.resetTriangulation(mdlData[orderIndex].data['triangulation'])
            mdlData[orderIndex].carrier = value;
            
            mdlData[orderIndex].data['courier'] = value.sign;
            const recipient = mdlData[orderIndex].data.recipient;
            const countryCode = recipient.country.countryCode;
            const carrierName = value.name;

            if(carrierName === UPSCourier && countryCode === canadaCountryCode) {
                this.changeProvinceFieldType(recipient, this.state.newCanadaProvinceCodes);
                this.toggleMandatoryField({
                    field: 'province',
                    mandatory: true,
                    data: recipient
                });
            } else if(carrierName === UPSCourier && countryCode === USCountryCode) {
                this.changeProvinceFieldType(recipient, this.state.newUSProvinceCodes);
                this.toggleMandatoryField({
                    field: 'province',
                    mandatory: true,
                    data: recipient
                });
            } else {
                this.changeProvinceFieldType(recipient, [], "text");
                const items = {
                    cityName:  recipient.city.value,
                    provinceCode: recipient.province.value,
                    zipCode: recipient.zip.value,
                }
                if(!this.getProvinceName(items) || (carrierName !== UPSCourier && countryCode === canadaCountryCode) || (carrierName !== UPSCourier && countryCode === USCountryCode)) {
                    this.toggleMandatoryField({
                        field: 'province',
                        mandatory: false,
                        data: recipient
                    });
                    recipient.province.value = '';
                } else if(this.getProvinceName(items)) {
                    this.toggleMandatoryField({
                        field: 'province',
                        mandatory: true,
                        data: recipient
                    });
                    recipient.province.value = items.provinceCode;
                }
                
                this.removeFieldErrors(data, "province");
            }

        } else if(type == 'triangulation') {
            mdlData[orderIndex].data['triangulation'][name].value = value;
        }

        this.setState({ modalMultiData: mdlData });
    }

    resetCarriers(carrierName) {
        let mdlData = this.state.modalMultiData;
        let carrier = mdlData[0].carriers.find(el => el.sign == carrierName);
        let errors = [];
        for (let [orderIndex, item] of mdlData.entries()) {
            let ret = validateCarrierRules(
                carrier,
                item.number,
                item.data.packages,
                item.data.recipient.zip.value,
                item.data.services && item.data.services.chkCountersign && item.data.services.chkCountersign.val,
                item.data.recipient.country.value,
                item.data.services);

            if (ret != null && ret.length > 0) {
                errors = [...errors, ...ret];
            }
            else {
                item.carrier = carrier;
                item.data.courier = carrier.sign;

                const countryCode = item.data.recipient.country.countryCode;
                const recipient = mdlData[orderIndex].data.recipient;

                if(carrierName === UPSCourier && countryCode === canadaCountryCode) {
                    this.changeProvinceFieldType(recipient, this.state.newCanadaProvinceCodes);
                    this.toggleMandatoryField({
                        field: 'province',
                        mandatory: true,
                        data: recipient
                    });
                    
                } else if(carrierName === UPSCourier && countryCode === USCountryCode) {
                    this.changeProvinceFieldType(recipient, this.state.newUSProvinceCodes);
                    this.toggleMandatoryField({
                        field: 'province',
                        mandatory: true,
                        data: recipient
                    });
                } else {
                    this.changeProvinceFieldType(recipient, [], "text");
                    const items = {
                        cityName:  recipient.city.value,
                        provinceCode: recipient.province.value,
                        zipCode: recipient.zip.value,
                    }
                    if(!this.getProvinceName(items)) {
                        this.toggleMandatoryField({
                            field: 'province',
                            mandatory: false,
                            data: recipient
                        });
                        recipient.province.value = '';
                      } else if(this.getProvinceName(items)) {
                          this.toggleMandatoryField({
                            field: 'province',
                            mandatory: true,
                            data: recipient
                        });
                        recipient.province.value = items.provinceCode;
                      }

                }
            }
        }
        if (errors.length > 0) {
            this.props.popupErrorMessage(errors);
        }
        else {
            let msg = Languages.getSection("OrderCreation").messages.carrierReset;
            let obj = {
                title: carrier.name,
                icon: "info",
                messages: msg.messages,
                buttons: [{ name: "ok", type: "confirm", text: "Ok" }]
            };
            this.props.popupMessage(obj);
        }

    }
    

    countrySelected(ev, type, orderIndex, fieldName, countryName, countryCode) {
        let mdlData = this.state.modalMultiData;
        const carrierName = mdlData[orderIndex].carrier.name;
        mdlData[orderIndex].data[type][fieldName].value = countryName;
        mdlData[orderIndex].data[type][fieldName].countryCode = countryCode;
        mdlData[orderIndex].data[type]['city'].value = '';
        mdlData[orderIndex].data[type]['province'].value = '';
        mdlData[orderIndex].data[type]['zip'].value = '';
        mdlData[orderIndex].data[type]['city'].suggestedCity = []


        const recipientData = mdlData[orderIndex].data.recipient;

        if(carrierName === UPSCourier && countryCode === canadaCountryCode) {
            this.changeProvinceFieldType(mdlData[orderIndex].data.recipient, this.state.newCanadaProvinceCodes);
            this.toggleMandatoryField({
                field: 'province',
                mandatory: true,
                data: recipientData
            });
        } else if(carrierName === UPSCourier && countryCode === USCountryCode) {
            this.changeProvinceFieldType(mdlData[orderIndex].data.recipient, this.state.newUSProvinceCodes);
            this.toggleMandatoryField({
                field: 'province',
                mandatory: true,
                data: recipientData
            });
        } else {
            this.changeProvinceFieldType(mdlData[orderIndex].data.recipient, [], "text");
            mdlData[orderIndex].data.recipient.province.value = '';
        }

        this.setState({ modalMultiData: mdlData });
    }

    toggleMandatoryField(items) {
        const { field, mandatory, data } = {...items};
        const columnItems =  data.fieldsValidation
        columnItems[field].mandatory = mandatory;
    }

    removeFieldErrors(data, fieldTypes) {
        if(typeof fieldTypes == 'object') {
            for(let fieldType of fieldTypes) {
                if(Object.hasOwn(data, fieldType)) {
                    delete data[fieldType].error;
                }
            }
        } else {
            delete data[fieldTypes].error;
        }
    }

    citySelected(ev, type, orderIndex, packIndex, name, value, items) {
        
        let mdlData = [...this.state.modalMultiData];
        mdlData[orderIndex].data[type][name].value = this.getCityName(items);
        mdlData[orderIndex].data[type]['province'].value = this.getProvinceName(items);
        mdlData[orderIndex].data[type]['zip'].value = this.getZipCode(items);
        const data = mdlData[orderIndex].data[type];
        const carrierName = mdlData[orderIndex].carrier.name;
        const countryCode = mdlData[orderIndex].data.recipient.country.countryCode;
        const recipientData = mdlData[orderIndex].data.recipient;
        
        if(!this.getProvinceName(items)) {
            this.toggleMandatoryField({
                field: 'province',
                mandatory: false,
                data: data
            });
          } else if(this.getProvinceName(items)) {
              this.toggleMandatoryField({
                field: 'province',
                mandatory: true,
                data: data
            });
        }

        if(carrierName === UPSCourier && countryCode === canadaCountryCode) {
            this.changeProvinceFieldType(mdlData[orderIndex].data.recipient, this.state.newCanadaProvinceCodes);
            this.toggleMandatoryField({
                field: 'province',
                mandatory: true,
                data: recipientData
            });
        } else if(carrierName === UPSCourier && countryCode === USCountryCode) {
            this.changeProvinceFieldType(mdlData[orderIndex].data.recipient, this.state.newUSProvinceCodes);
            this.toggleMandatoryField({
                field: 'province',
                mandatory: true,
                data: recipientData
            });
            
        } else {
            this.changeProvinceFieldType(mdlData[orderIndex].data.recipient, [], "text");
            mdlData[orderIndex].data.recipient.province.value = this.getProvinceName(items);
        }
        


        if(!this.getZipCode(items)) {
            this.toggleMandatoryField({
                field: 'zip',
                mandatory: false,
                data: data
            });
        } else {
            this.toggleMandatoryField({
                field: 'zip',
                mandatory: true,
                data: data
            });
        }
        this.removeFieldErrors(data, ["city", "province", "zip"]);
        this.setState({ modalMultiData: mdlData });
    }


    getCityName(cityObject) {
        const cityName = cityObject?.cityName;
        const labelShort = cityObject?.labelShort;
        const zipCode = cityObject?.zipCode;
        
        if(cityName) {
            return cityName;
        }

        if(zipCode && zipCode.length > 0) {
            return labelShort.split(zipCode)[0].trim()
        }

        if(!cityName) {
            return labelShort.trim();
        }

        if(zipCode && zipCode.length === 0) {
            return ''
        }
    }

    getProvinceName(cityObject) {
        const cityName = cityObject?.cityName;
        const provinceCode = cityObject?.provinceCode;
        if(cityName) {
            return provinceCode;
        }

        if(!cityName && provinceCode) {
            return provinceCode;
        }

        if(!cityName && !provinceCode) {
            return '';
        }
    }

    getZipCode(cityObject) {
        const cityName = cityObject?.cityName;
        // const labelShort = cityObject?.labelShort;
        const provinceCode = cityObject?.provinceCode;
        const zipCode = cityObject?.zipCode;

        if(cityName) {
            return zipCode;
        }

        if(!cityName && zipCode) {
            return zipCode;
        }

        if(!cityName && !provinceCode) {
            return '';
        }
    }

    removeMultiple(ev, orderIndex, packIndex) {
        let mdlData = this.state.modalMultiData;
        mdlData[orderIndex].data.packages.splice(packIndex, 1);
        this.setState({ modalMultiData: mdlData });
    }

    changeAddress(ev,val) {
        let order = this.findOrderById(val.dataVal);
        if (order != null) {
            this.setState({ modalType: 5, modalAddressReference:order.id, modalAddress: this.buildModalAdress(order) });
        }
    }

    modalAddressClick(ev, action) {
        try {
            if (!action)
                this.setState({ modalType: 0, modalAddressReference: '' });
            else {
                this.props.loaderShow(0);
                let orderDto = this.buildAddressOrderDto(this.state.modalAddress.normalized);
                this.orderAddressNorm(this.state.modalAddressReference, orderDto, this.uc.jwtToken,
                    address => {
                        this.props.loaderHide();
                        this.setState({ modalType: 0 });
                        let me = this;
                        var exitPopup = function () {
                            let navigation = me.state.navigation;
                            me.getData(navigation);  
                        }
                        let title = this.le.addressNormModal.title;
                        let msg = this.le.addressNormModal[address.shipAddressStatus.toLowerCase()];
                        let obj = {
                            title: title,
                            width: "35%",
                            icon: "info",
                            messages: [msg],
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                        };
                        this.props.popupMessage(obj);
                    },
                    error => {
                        this.props.loaderHide();
                        const msg = this.le.messages.error;
                        let messages = error != undefined && error != null && error.hasOwnProperty("errorMessage") ? [error.errorMessage] :
                            msg.messages
                        this.props.popupErrorMessage(messages);

                    });


               
            }
        }
        catch (e) {
            this.props.loaderHide();
            const msg = this.le.messages.error;
            this.props.popupErrorMessage(msg.messages);
        }

    }

    modalAddressChange(ev, who, value, name) {
        let item = this.state.modalAddress.normalized.items.find(a => a.id == name);
        if (item != null) {
            item.value = value;
            this.setState({ 
                modalAddress: this.state.modalAddress,
            });
        }
    }

    scrollMarketplace(ev, direction) {
        if (this.state.marketPlaceListConf.length > 1) {
            let list = this.state.marketPlaceListConf;
            if (direction < 0) {
                //left
                list.unshift(list[list.length - 1]);
                list = list.splice(0, list.length - 1)
            }
            else if (direction > 0) {
                //right
                list.push(list[0]);
                list = list.splice(1);
            }
            this.setState({ marketPlaceListConf: list });
        }
    }

  
    //#endregion Events

    render() {
        //#region Data Structures
        let modal, filters = {};
        
        Object.entries(this.configs.filters).forEach(([key, val]) => {
            filters[key] = Object.assign({ value: this.state.filters[key] }, val);
        }, this);
        //#endregion Data Structures

        switch (this.state.modalType) {
            case 1: {}
                break;
            case 2: {}
                break;
            case 3: {
                
                    modal = (
                        <OrderCreationMultiManageBox
                            popupErrorMessage={this.props.popupErrorMessage}
                            popupMessage={this.props.popupMessage}
                            texts={this.le.manage}
                            data={this.state.modalMultiData}
                            packageItems= {this.state.packageItems}
                            onPackageOptionChange={this.onPackageOptionChange}
                            onClick={this.clickMultiple}
                            onChange={this.changeMultiple}
                            onAdd={this.addMultiple}
                            onRemove={this.removeMultiple}
                            suggestedCountry={this.state.suggestedCountry}
                            countries = {this.state.countries}
                            suggestedCity={this.state.suggestedCity}
                            onCitySelected = {this.citySelected}
                            onCountrySelected = {this.countrySelected}
                            onResetCarriers = {this.resetCarriers}
                            />
                    );
                }
                break;
            case 4: {
                    modal = <UIMessageBox
                        type="question"
                        title={this.le.assuranceModal.captions}
                        message={
                            [<div>{this.le.assuranceModal.messages[0]}</div>, <div><a href={this.le.assuranceModal.link} target="_BLANK">{this.le.assuranceModal.linkText}</a></div>]
                        }>

                        <UIButton key="btn-01" className="confirm" text={this.le.assuranceModal.okText} onClick={this.acceptedAssurance} />
                        <UIButton key="btn-02" text={this.le.assuranceModal.cancelText} onClick={this.notAcceptedAssurance} />
                    </UIMessageBox>
                }
                break;
            case 5: {
                    // AL MOMENTO NON ESISTE ANCORA..SARA DA FARE
                    const buttons = [
                        { class: "bigger", type: "confirm", text: this.le.addressNormModal.confirm, click: ((ev) => (this.modalAddressClick(ev, true))) },
                        { class: "bigger", type: "cancel", text: this.leMain.buttons.cancel, click: ((ev) => (this.modalAddressClick(ev, false))) }];
                    modal = (
                        <ModalBoxFluid width="70%" className="titleThin" title={this.le.addressNormTitle} buttons={buttons} onClose={((ev) => (this.modalAddressClick(ev, false)))}>
                            <div class="row">
                                <div class="col">
                                    <h4>{this.le.addressNorm}</h4>
                                    <div className="input-section-small">
                                        <InputColumn column={this.state.modalAddressReference} data={this.state.modalAddress.normalized} onChange={this.modalAddressChange} />
                                    </div>
                                </div>
                                <div class="col">
                                    <h4>{this.le.addressOrig}</h4>
                                    <div className="input-section-small">
                                        <InputColumn column={this.state.modalAddressReference} data={this.state.modalAddress.original} onChange={null} />
                                    </div>
                                </div>
                            </div>
                        </ModalBoxFluid>
                    );
                }
                break;
            case 7: {
                    this.state.modalMsg = '';
                    modal = (<OrderCostMessage onAction={this.carrierCostModalAction} carrierCostCalcDto={this.carrierCostCalcDto} userContext={this.uc} />);
                }
                break;

            case 8:
                
                const message = {
                    ...this.le.messages.euCountry
                };
             
                const nonEuNumberOrders = this.state.nonEuOrders;
                const newMessage = 'Numeri Ordine EXTRA EU: ' + nonEuNumberOrders.join(', ');
                message.messages.unshift(newMessage);
                modal = <UIMessageBox
                    type="info"
                    title={message.captions}
                    message={message.messages}>
                    <UIButton key="btn-0" className="confirm" text={message.button} onClick={this.hasCreditBox() ? this.continueCalculateCarrierCost: this.confirmOrder}/>
                </UIMessageBox>
               
                break;
            default:
                modal = (<div />);
                break;
        }


        let icons = this.state.marketPlaceListConf.map((el, idx) => {
            if (el.file) {
                let fileRef = React.createRef();
                let uploader = <UIUpload ref={fileRef} style={{ display: 'none' }} key={"uploadCsv" + idx} onChange={ev => this.actionClick(ev, 'uploadCSV', el.name.toLowerCase() + 'csv')} />;
                let item = <ScrollableGridItem key={idx} id={el.id} icon={el.logo} title={el.name} onClick={(ev) => {
                    fileRef.current.onClick(ev)
                }} />;
                return [item, uploader];
            }
            else {
                let item = <ScrollableGridItem key={idx} id={el.id} icon={el.logo} title={el.name} onClick={this.logoClick} />;
                return item;
            }
        });

        let pageFilters = Object.entries(filters).map(([key, val]) => {
            switch (val.type) {
                case "select":
                    return <UISelect key={key} name={key} options={val.options} value={val.value} onChange={this.filtersChange} />;
                case "checkbox":
                    return <UICheckbox key={key} name={key} onChange={this.filtersChange} value={val.value} label={this.le.filters.items[key]} />;
                default:
                    return <UIInput key={key} type={val.type} name={key} maxDate={new Date()} onChange={this.filtersChange} value={val.value} hint={this.le.filters.items[key]} />;
            }
        }, this);
        pageFilters.push(<UIButton key="btn-0" text={this.le.buttonManage} onClick={this.manageMultipleOrders} />);

        let credits = <CreditBoxWidget
            navigateTo={this.props.navigateTo}
            orderTotal={this.state.orderCarrierCost}>
        </CreditBoxWidget>;


        let ebayConnector = this.state.ebayConnector ? <EbayConnector
            onDone={(x) => { this.ebayLogoClick(x) }}
            ebayDto={this.state.marketPlaceListConf.find(el => el.name.toLowerCase() == 'ebay').marketPlacePars}
            forceLogin={false}
            popupErrorMessage={this.props.popupErrorMessage}
        /> : null;

        let buttons = null;
        if (this.state.entries.length > 0) {
            buttons = [
                <UIButton key="btn-1" className="confirm" text={this.le.buttonAll} onClick={this.createAllOrder} />,
                <UIButton key="btn-2" className="confirm" text={this.le.button} onClick={this.createOrder} />,
                <UIButton key="btn-3" className="delete" text={this.le.deleteOrder} onClick={this.deleteOrders} />,
                <UIButton key="btn-4" className="delete" text={this.le.deleteAllOrder} onClick={this.deleteAllOrders} />
            ];
            if (this.hasCreditBox())
                buttons.unshift(<UIButton key="btn-0" className="confirm" text={this.le.buttonCost} onClick={this.calculateCarrierCost} />);
            buttons = <UIButtonPad align="right">
                {buttons}
            </UIButtonPad>;
        }
               
        return <div className="page-order-creation">
            <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.ordersCreate}>{credits}</PageTitle>
            <div className="page-content">
                <UISummary>
                    <UISummaryWidgetBar>
                        <div className="file-transfer-panel">
                            <div className="widget-bar-title">{this.le.creation.transferTitle}</div>
                            <UIUpload key="uploadCsv" title={this.le.creation.csv[0]} onChange={ev => this.actionClick(ev,'uploadCSV','csv')}/>
                            <UIDownload key="downloadCSV" title={this.le.creation.csv[1]} onClick={ev => this.actionClick(ev, 'downloadCSV')} />
                            <UIDownload key="downloadCSVInfo" title={this.le.creation.csv[2]} onClick={ev => this.actionClick(ev, 'downloadCSVInfo')} />
                        </div>
                        <div className="marketplace-panel">
                            <div className="panel-title">{this.le.creation.marketplaceTitle}</div>
                            <div className="marketplace-container">
                                <ScrollableGrid>
                                    {icons}
                                </ScrollableGrid>
                                <div className="scroll-panel">
                                    <div className={"arrow-right " + (icons.length > 1 ? '' : 'disabled')} onClick={(ev) => (this.scrollMarketplace(ev,+1))} />
                                    <div className={"arrow-left " + (icons.length > 1 ? '' : 'disabled')} onClick={(ev) => (this.scrollMarketplace(ev, -1))} />
                                </div>
                            </div>
                        </div>
                    </UISummaryWidgetBar>
                </UISummary>

                <TaskExecutingUserMessage userContext={this.uc} title={this.le.message.orderLoadingTitle}
                    ref={this.userOrderRunningMessage} onCompleted={this.onCompletedTaskExecuting}
                    message={this.le.message.csvUploaded} userMessageTimeout={this.props.userMessageTimeout} />
                <UserMessage section="CSV-UPLOAD-ERROR"
                    typeMessage="alert-danger"
                    userContext={this.uc} title={this.le.message.orderLoadingError} ref={this.userErrorMessage} />

                <UIFilterPanel>
                    {pageFilters}
                </UIFilterPanel>


                <UIDataTable
                    header={this.header} 
                    entries={this.state.entries}
                    listKey={this.listKey}
                    managers={this.state.managers}
                    navigation={this.state.navigation} />

                { buttons }


            </div>
            {modal}
            {ebayConnector}
        </div>;
    }
}


class OrderCreationMultiManageBox extends React.Component {
    constructor(props) {
        super(props);
        this.Click = this.Click.bind(this);
        this.resetCarriers = this.resetCarriers.bind(this);
        this.dataChange = this.dataChange.bind(this);
        this.packageOptionSelected = this.packageOptionSelected.bind(this);
        this.addPackage = this.addPackage.bind(this);
        this.removePackage = this.removePackage.bind(this);
        this.countrySelected = this.countrySelected.bind(this);
        this.citySelected = this.citySelected.bind(this);
    }

    Click(ev, type) {
        this.props.onClick(ev, type === "confirm");
    }

    resetCarriers(ev) {
        // let sign = ev.target.value;
        // let carrier = this.props.data[0].carriers.find(el => el.sign == sign);
        // let errors = [];
        // debugger

        // for (let item of this.props.data) {
        //     let ret = validateCarrierRules(carrier, item.number, item.data.packages, item.data.recipient.zip.value, item.data.services && item.data.services.chkCountersign && item.data.services.chkCountersign.val, item.data.recipient.country.value);

        //     if (ret != null && ret.length > 0) {
        //         errors = [...errors, ...ret];
        //     }
        //     else {
        //         item.carrier = carrier;
        //         item.data.courier = carrier.sign;
        //     }
        // }
        // if (errors.length > 0) {
        //     this.props.popupErrorMessage(errors);
        // }
        // else {
        //     let msg = Languages.getSection("OrderCreation").messages.carrierReset;
        //     let obj = {
        //         title: carrier.name,
        //         icon: "info",
        //         messages: msg.messages,
        //         buttons: [{ name: "ok", type: "confirm", text: "Ok" }]
        //     };
        //     this.props.popupMessage(obj);
        // }

        let carrierName = ev.target.value;

        this.props.onResetCarriers(carrierName);
    }

    dataChange(ev, type, orderIndex, packIndex, name, value, items) {
        this.props.onChange(ev, type, orderIndex, packIndex, name, value, items);
    }

    packageOptionSelected(selectedPackageId, orderIndex, packageIndex) {
        this.props.onPackageOptionChange(selectedPackageId, orderIndex, packageIndex)
    }

    countrySelected(ev, type, orderIndex, fieldName, countryName, countryCode) {
        this.props.onCountrySelected(ev, type, orderIndex, fieldName, countryName, countryCode);
    }

    citySelected(ev, type, orderIndex, packIndex, name, value, items) {
        this.props.onCitySelected(ev, type, orderIndex, packIndex, name, value, items);
    }

    addPackage(ev, orderIndex, packageIndex) {
        this.props.onAdd(ev, orderIndex, packageIndex);
    }

    removePackage(ev, orderIndex, packIndex) {
        this.props.onRemove(ev, orderIndex, packIndex);
    }

    render() {
        const le = this.props.texts;
        
        const items = this.props.data.map((elm, idx) => {
            return (
                <OrderCreationManage
                    popupErrorMessage={this.props.popupErrorMessage}
                    popupMessage={this.props.popupMessage}
                    key={"ocm-" + idx}
                    texts={this.props.texts}
                    index={idx}
                    collapsable={this.props.data.length > 1}
                    onChange={this.dataChange}
                    onPackageOptionSelected={this.packageOptionSelected}
                    onAdd={this.addPackage}
                    onRemove={this.removePackage}
                    source={"ocm." + idx}
                    data={elm.data}
                    packageOptions={elm.data.packageOptions}
                    carriers={elm.carriers}
                    order={{
                        order: elm.order, 
                        number: elm.number,
                        customer: elm.customer,
                        warehouse: elm.warehouse,
                        warehouseObj: elm.warehouseObj,
                        marketplace: elm.marketplace,
                        carrier:elm.carrier
                    }}
                    suggestedCountry={this.props.suggestedCountry}
                    suggestedCity={this.props.suggestedCity}
                    countries={this.props.countries}
                    onCitySelected={this.citySelected}
                    onCountrySelected={this.countrySelected} />
            );
        }, this);

        let buttons = [];
        if (this.props.data.length > 1) {
            let carriers = this.props.data[0].carriers.map(i => ({ value: i.sign, text: i.sign }));
            carriers.unshift({value: '', text: le.buttons.carrier });
            buttons.push(<UISelect key={uuidv4()} name="reset_carrier" options={carriers} onChange={this.resetCarriers} />);
        }
        buttons.push(<UIButton key="confirm" text={le.buttons.confirm} onClick={(ev) => (this.Click(ev, 'confirm'))} className={"slim confirm"} />);

        return (
            <UIPopup 
                title={this.props.data.length > 1 ? le.titleMultiple : le.title}
                buttons={buttons}
                className="order-creation-popup button-pad-right"
                onCancel={(ev) => (this.Click(ev, false))}>
                {items}
            </UIPopup>
        );
    }
}


export class OrderCreationManage extends React.Component {
    constructor(props) {
        super(props);
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.Change = this.Change.bind(this);
        this.packageChange = this.packageChange.bind(this);
        this.carrierChange = this.carrierChange.bind(this);
        this.addressChange = this.addressChange.bind(this);
        this.triangulationChange = this.triangulationChange.bind(this);
        this.addPackage = this.addPackage.bind(this);
        this.removePackage = this.removePackage.bind(this);
        this.enterEditAddress = this.enterEditAddress.bind(this);
        this.onAutocompleteCountryChange = this.onAutocompleteCountryChange.bind(this);
        this.onAutocompleteCountrySelected = this.onAutocompleteCountrySelected.bind(this);
        this.onSelectCountryChange =  this.onSelectCountryChange.bind(this)

        this.onAutocompleteCityChange = this.onAutocompleteCityChange.bind(this);
        this.onAutocompleteCitySelected = this.onAutocompleteCitySelected.bind(this);
        this.onPackageOptionChanged = this.onPackageOptionChanged.bind(this);

        let mustEditRecipient = false;
        Object.entries(props.texts.recipient.inputs).map(([key, val], idx) => {
            if (props.data.recipient[key].error) {
                mustEditRecipient = true;
            }
                
        });

        this.state = {
            expanded: this.props.collapsable ? false : true,
            editRecipient: mustEditRecipient,
        }
    }

    getSenderAddress(order) {
        if (order.warehouseObj && order.warehouseObj.hasOwnProperty("isAddressFromOrder") && order.warehouseObj.isAddressFromOrder)
            return order.order.orderSender.getAddress();
        else if (order.warehouseObj) {
            let warehouse = order.warehouseObj;
            return warehouse.address +
                (warehouse.city && warehouse.city != "" ? " " + warehouse.city : "") +
                (warehouse.city && warehouse.city != "" ? " " + warehouse.city : "") +
                (warehouse.houseNo && warehouse.houseNo != "" ? " " + warehouse.houseNo : "") +
                (warehouse.province && warehouse.province != "" ? " " + warehouse.province : "") +
                (warehouse.zip && warehouse.zip != "" ? " " + warehouse.zip : "");
        }
        return "";
    }

    enterEditAddress(ev) {
        this.setState({ editRecipient: true });
    }

    Change(ev, name, value, type) {
        let who = name.split(".");
        this.props.onChange(ev, who, value, type);
    }

    packageChange(ev, orderIndex, packIndex) {
        this.props.onChange(ev, "packages", orderIndex, packIndex, ev.target.name, ev.target.value);
    }

    onPackageOptionChanged(ev, orderIndex, packageIndex) {
        const selectedPackageId = ev.currentTarget.value;
        this.props.onPackageOptionSelected(selectedPackageId, orderIndex, packageIndex)
    }

    carrierChange(ev, orderIndex) {
        if (ev.target.name == 'carrier') {
            let carrier = this.props.carriers.find(el => el.sign == ev.target.value);
            if (carrier) {
                let ret = validateCarrierRules(
                    carrier,
                    this.props.order.number,
                    this.props.data.packages,
                    this.props.data.recipient.zip.value,
                    this.props.data.services && this.props.data.services.chkCountersign && this.props.data.services.chkCountersign.val,
                    this.props.data.recipient.country.value,
                    this.props.data.services);
                if (ret != null && ret.length > 0) {
                    this.props.popupErrorMessage(ret);
                }
                else {
                    
                    this.props.onChange(ev, "carrier", orderIndex, -1, "courier", carrier);
                }
            }

        }
    }

    serviceChange(ev, orderIndex) {
        // debugger

        if (ev.target.type == 'checkbox') {
            this.props.onChange(ev, "services", orderIndex, -1, ev.target.name, ev.target.checked);
        }
        else {
            this.props.onChange(ev, "servicesdata", orderIndex, -1, ev.target.name, ev.target.value);
        }
            
    }

    addressChange(ev, orderIndex) {
        this.props.onChange(ev, "recipient", orderIndex, -1, ev.target.name, ev.target.value);
    }

    triangulationChange(ev, orderIndex) {
        this.props.onChange(ev, "triangulation", orderIndex, -1, ev.target.name, ev.target.value);
    }


    onSelectCountryChange(ev, orderIndex, fieldName,  countryName, countryCode, source) {
        this.props.onCountrySelected(ev, source, orderIndex, fieldName, countryName, countryCode);
    }

    addPackage(ev, orderIndex, packageIndex) {
        this.props.onAdd(ev, orderIndex, packageIndex);
    }

    removePackage(ev, orderIndex, packIndex) {
        this.props.onRemove(ev, orderIndex, packIndex);
    }

    onAutocompleteCityChange(ev, orderIndex, name, value, source) {
        // this.props.onChange(ev, "recipient", orderIndex, -1, name, value);
        this.props.onChange(ev, source, orderIndex, -1, name, value);
    }

    onAutocompleteCitySelected(orderIndex, name, value, items, source) {
        this.props.onCitySelected(null, source, orderIndex, -1, name, value, items)
        // this.props.onCitySelected(null, "recipient", orderIndex, -1, name, value, items)
    }

    onAutocompleteCountryChange(ev, orderIndex, name, value) {
        this.props.onChange(ev, "recipient", orderIndex, -1, name, value);
    }

   

    onAutocompleteCountrySelected(orderIndex, name, value) {
        this.props.onCountrySelected(null, "recipient", orderIndex, -1, name, value)
    }


    buildAddressBlock(orderIndex) {
        let recipient = this.props.data.recipient;
        let inputs = Object.entries(this.props.texts.recipient.inputs).map(([key, val], idx) => {
            if(key === 'country') {

                return  <SelectField
                            label={val}
                            orderIndex={orderIndex}
                            key={key}
                            name={key}
                            source="recipient"
                            className=""
                            options={recipient[key].suggestedCountry} 
                            value={recipient[key].value}
                            mandatory={recipient.fieldsValidation[key].mandatory}
                            onSelectChange={this.onSelectCountryChange} />;
            } 
            if(key === 'city') {
                return <UIAutocomplete 
                        type="autocomplete"
                        source='recipient'
                        key={key}
                        item={key}
                        name={key}
                        label={val}
                        orderIndex={orderIndex}
                        options = {recipient[key].suggestedCity}
                        value={recipient[key].value}
                        error={recipient[key].error}
                        mandatory={recipient.fieldsValidation[key].mandatory}
                        maxLength={recipient.fieldsValidation[key]?.maxLength}
                        onAutocompleteCityChange={this.onAutocompleteCityChange}
                        onAutocompleteCitySelected={this.onAutocompleteCitySelected} />
            }
            // console.log(recipient.fieldsValidation[key],"recipient.fieldsValidation[key]")
            if(recipient[key].type === 'select') {
                return <UISelect
                            label={val}
                            orderIndex={orderIndex}
                            key={key}
                            name={key}
                            source="recipient"
                            className=""
                            options={recipient[key].options} 
                            value={recipient[key].value}
                            mandatory={recipient.fieldsValidation[key].mandatory}
                            error={recipient[key].error}
                            onChange={(ev) => this.addressChange(ev, orderIndex)} />;
            }
            return <UIInput
                    type={recipient[key].type}
                    key={key}
                    name={key}
                    label={val}
                    value={recipient[key].value}
                    error={recipient[key].error}
                    mandatory={recipient.fieldsValidation[key].mandatory}
                    maxLength={recipient.fieldsValidation[key]?.maxLength}
                    onChange={(ev) => this.addressChange(ev, orderIndex)} />
        });
        return <div className='order-address-fields'>{inputs}</div>;
    }

    buildDefaultTriangulationFields() {
        return {
            address: {
                value: ''
            },
            address: {
                value: ''
            }
        }
    }


    buildTriangulationBlock(orderIndex) {
        let triangulation = this.props.data.triangulation;
        let inputs = Object.entries(this.props.texts.triangulation.inputs).map(([key, val], idx) => {
            if(key === 'country') {
               return  <SelectField
                            label={val}
                            orderIndex={orderIndex}
                            key={key}
                            name={key}
                            source="triangulation"
                            className=""
                            options={triangulation[key].suggestedCountry} 
                            value={triangulation[key].value}
                            mandatory={triangulation.fieldsValidation[key].mandatory}
                            onSelectChange={this.onSelectCountryChange} />;
            } 
            if(key === 'city') {
                return <UIAutocomplete 
                        type="autocomplete"
                        key={key}
                        item={key}
                        name={key}
                        label={val}
                        source="triangulation"
                        orderIndex={orderIndex}
                        options = {triangulation[key].suggestedCity}
                        value={triangulation[key].value}
                        error={triangulation[key].error}
                        mandatory={triangulation.fieldsValidation[key].mandatory}
                        maxLength={triangulation.fieldsValidation[key].maxLength}
                        onAutocompleteCityChange={this.onAutocompleteCityChange}
                        onAutocompleteCitySelected={this.onAutocompleteCitySelected} />
            }
            return <UIInput
                    type="text"
                    key={key}
                    name={key}
                    label={val}
                    value={triangulation[key].value}
                    error={triangulation[key].error}
                    mandatory={triangulation.fieldsValidation[key].mandatory}
                    maxLength={triangulation.fieldsValidation[key].maxLength}
                    onChange={(ev) => this.triangulationChange(ev, orderIndex)} />
        });
        return <div className='order-address-fields'>{inputs}</div>;
    }

    render() {
        const languageTexts = this.props.texts
        const svcs = this.props.data.services
        const pkg = this.props.data.packages;

        if (!svcs.chkAssurance) {
            svcs.chkAssurance = {};
        }
            
        if (!svcs.chkCountersign) {
            svcs.chkCountersign = {};
        }


        let packageCols = [];

        pkg.forEach((element, index) => {
            let props = Object.entries(element);
            let orderprops = languageTexts.package.properties;
            for (let i = 0; i < orderprops.length; i++) {
                let from = props.findIndex(element => element[0] == orderprops[i]);
                if (from != i)
                    props.splice(i, 0, props.splice(from, 1)[0]); //moves 
            }
            const packageData = props.map(([key, obj], idx) => Object.assign(
                {
                id: key, item: key + "." + index,
                text: languageTexts.package.inputs[idx],
                unit: languageTexts.package.units[idx],
                type: 'text'
                }, obj)
            , this);

            

            packageCols.push(
                <UIOrderPackageConfig
                    key={index}
                    title={languageTexts.package.title + " " + (index + 1)}
                    texts={languageTexts.package}
                    data={packageData}
                    onAdd={index == pkg.length - 1 ? ((ev) => (this.addPackage(ev, this.props.index, pkg.length))) : null}
                    onRemove={pkg.length > 1 ? (ev) => this.removePackage(ev, this.props.index, index) : null}
                    onChange={(ev) => (this.packageChange(ev, this.props.index, index))}
                    packageOptionValue={this.props?.packageOptions[index]?.selectedDefaultValue}
                    packageOptions={this.props?.packageOptions[index]?.packageOptions}
                    packageOptionChange={(ev) => this.onPackageOptionChanged(ev, this.props.index, index)}
                    />
            );
        }, this);

        svcs.chkAssurance.enabled = true;
        svcs.chkCountersign.enabled = this.props.order.carrier.counterSign;
        svcs.chkTriangulation.enabled = this.props.order.carrier.triangulation;
        


        const services = Object.keys(svcs).map(function (key, idx) {
            return <div key={"chk-" + idx}>
                <UICheckbox 
                    key={"chk-" + idx}
                    name={key} value={svcs[key].val}
                    label={languageTexts.additionals.services[idx]}
                    disabled={!svcs[key].enabled}
                    onChange={(ev) => (this.serviceChange(ev, this.props.index, -1))} />

                    {key !== 'chkTriangulation' &&  <UIInput
                        key={"inp-" + idx}
                        name={key}
                        value={svcs[key].data}
                        disabled={!(svcs[key].enabled && svcs[key].val)}
                        onChange={(ev) => (this.serviceChange(ev, this.props.index, -1))}
                        error={svcs[key].val && svcs[key].error ? svcs[key].error : false} />}
               
            </div>;
        }, this);

        let receiverStyle = {};
        if (!this.state.expanded || this.state.editRecipient) {
            receiverStyle = { display: "none" };
        }
            
        let carriers = this.props.carriers.map(i => ({ value: i.sign, text: i.sign }));
        carriers.unshift({ value: '', text: '' });
        
        
        return <div className={"order-panel " + (this.state.expanded ? "" : "collapsed")} >
            <div className={"order-panel-header " + (this.state.expanded ? "" : "collapsed")}>
                <div>
                    <div className="order-panel-info">
                        <div className="ellipsis">{languageTexts.captions.orderNo}</div>
                        <div className="ellipsis">{this.props.order.number}</div>
                    </div>
                    <div className="order-panel-info">
                        <div className="ellipsis" style={this.state.expanded ? {} : { display: "none" }}>{languageTexts.captions.sender}</div>
                        <div className="ellipsis" style={this.state.expanded ? {} : { display: "none" }}>
                            {this.props.order.order.sender}
                            <div className="ellipsis" style={this.state.expanded ? {} : { display: "none" }}>{this.props.order.order.orderSender.getAddress()}</div>    
                        </div>
                    </div>
                    
                    <div className="order-panel-info">
                        <div className="ellipsis" style={receiverStyle}>{languageTexts.captions.destination}</div>
                        <div className="" style={receiverStyle}> {/* ellipsis */}
                            {this.props.order.order.receiver}
                            <div className="">
                                <div className="ellipsis edit-entry"
                                    style={receiverStyle}
                                    onClick={this.enterEditAddress} >
                                    {this.props.order.order.orderRecipient.getAddress()}
                                    <div className="package-section-edit"><img src={EditIcon} alt="edit-icon" /></div>
                                </div>
                            </div>    
                        </div>
                    </div>
                    <div className="order-panel-info" style={this.props.order.marketplace ? {} : {display: 'none'}}>
                    <div className="ellipsis" style={this.state.expanded ? {} : { display: "none" }}>{languageTexts.captions.marketplace}</div>
                    <div className="ellipsis" style={this.state.expanded ? {} : { display: "none" }}>{this.props.order.marketplace}</div>
                </div>
                    
                </div>
                <div className="order-panel-info">
                    <div className="ellipsis" style={this.state.expanded ? { display: "none" } : {}}>{languageTexts.captions.sender}</div>
                    <div className="ellipsis" style={this.state.expanded ? { display: "none" } : {}}>{this.props.order.order.sender}</div>
                </div>
                <div className="order-panel-info">
                    <div className="ellipsis" style={this.state.expanded ? { display: "none" } : {}}>{languageTexts.captions.destination}</div>
                    <div className="ellipsis" style={this.state.expanded ? { display: "none" } : {}}>{this.props.order.order.receiver}</div>
                </div>
                <div className={"order-panel-toggler " + (this.state.expanded ? 'on' : 'off')} style={this.props.collapsable ? {} : { display: "none" }}>
                    <div onClick={() => this.setState({ expanded: !this.state.expanded })}></div>
                </div>
            </div>
            <div className={"order-panel-body " + (this.state.expanded ? "" : "collapsed")}>
                <div className="order-address-container" style={this.state.editRecipient ? {} : { display: 'none' }}>
                    <div className="ellipsis order-address-title">{this.props.texts.recipient.title}</div>
                    {this.buildAddressBlock(this.props.index)}
                </div>

                
                <div className="creation-order-border-left ">
                    <div className="order-panel-info package-title-config">
                        {languageTexts.package.packageConfigTitle}
                    </div>
                    <div className="order-package-container">
                        {packageCols}
                    </div>
                    
                </div>

                <div className="order-carrier-container creation-order-border-left">
                    <div className="input-field input-field-label">{this.props.texts.carrier.title}</div>
                    <UISelect error={!this.props.data.courier} name="carrier" options={carriers} value={this.props.data.courier} onChange={(ev) => (this.carrierChange(ev, this.props.index))} />
                </div>

                <div className="order-service-container creation-order-border-left">
                    <div className="ellipsis order-service-title">{languageTexts.additionals.title}</div>
                    {services}
                </div>


                <div className={"order-address-container creation-order-border-left " + (this.props.data.services.chkTriangulation.val ? 'show' : 'hide')}>
                    <div className="ellipsis order-address-title">{this.props.texts.triangulation.title}</div>
                    {this.buildTriangulationBlock(this.props.index)}
                </div>
            </div>

        </div>;
    }
}